(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["banner-delivery-zone-checker"]) return;
  try {
    
// Section-Builder: 01-main.js
const HEADERS = {
    'User-Agent': 'CupcakeCentral/1.0 (rohit@cupcakecentral.com.au)',
  };
  const _LOADING = 'data-loading';
  const _SUCCESS = 'data-success';
  const _FAILURE = 'data-failure';

  /**
   * @typedef {Object} PostcodeInfo
   * @property {Set<string>} postcodes - Queriable set of postcodes.
   * @property {string} fee - The fee associated with the postcode.
   */

  /**
   * @typedef {Object} ExtractedAddress
   * @property {string} postcode - The extracted postcode.
   * @property {string} address - The remaining address without country/state.
   */

  class ZoneChecker extends HTMLElement {
    #form;
    #locationSpan;
    #extraInfoSpan;
    /** @type {PostcodeInfo[]} */
    #postcodeInfo = [];

    constructor() {
      super();

      this.#form = /** @type {HTMLFormElement} */ (this.throw.element('form'));
      this.#locationSpan = this.throw.element('[data-location]');
      this.#extraInfoSpan = this.throw.element('[data-name=extra-info]');
      const dataDivs = this.throw.any('[data-name=postcode-data]');
      dataDivs.forEach((element) => {
        const postcode = element.getAttribute('data-postcodes');
        const fee = element.getAttribute('data-fee');
        if (!postcode || !fee) {
          throw Error(`Missing postcode or fee for element: ${element.outerHTML}`);
        }
        const postcodeSet = new Set(postcode?.split(',').map((code) => code.trim()) ?? []);
        this.#postcodeInfo.push({
          postcodes: postcodeSet,
          fee: fee,
        });
      });

      this.#addFormListener();
      this.#backListener();
    }

    #backListener() {
      this.throw.element('[data-reset]').addEventListener('click', () => {
        this.removeAttribute(_SUCCESS);
        this.removeAttribute(_FAILURE);
      });
    }

    #addFormListener() {
      this.#form?.addEventListener('submit', async (e) => {
        const event = /** @type {SubmitEvent} */ (e);
        const eventTarget = /** @type {HTMLFormElement} */ (event.target);

        event.preventDefault(); // No reload.
        this.setAttribute(_LOADING, '');

        try {
          const formData = new FormData(eventTarget);
          const userInput = formData.get('user-postcode')?.toString().trim();

          if (userInput === undefined || userInput === '') return;

          const result = await queryNominatim(userInput).catch((error) => {
            console.error(error);
            return null;
          });

          if (!result) {
            this.setAttribute(_FAILURE, '');
            logMissingPostcode(userInput);
          } else {
            const { postcode, address } = result;
            const { ok, fee } = this.#checkPostcode(postcode);
            if (ok) {
              this.#locationSpan.textContent = address;
              this.#extraInfoSpan.textContent = fee;
              this.setAttribute(_SUCCESS, '');
            } else {
              this.setAttribute(_FAILURE, '');
              logMissingPostcode(userInput);
            }
          }
        } finally {
          this.removeAttribute(_LOADING);
        }
      });
    }

    #checkPostcode(postcode) {
      for (const info of this.#postcodeInfo) {
        if (info.postcodes.has(postcode)) {
          return {
            ok: true,
            fee: info.fee,
          };
        }
      }
      return {
        ok: false,
        fee: null,
      };
    }
  }

  customElements.define('zone-checker', ZoneChecker);

  /**
   * Extracts the postcode from the given query string.
   * @param {string} query - The query string to extract the postcode from.
   * @returns {ExtractedAddress|null} - The extracted postcode and address, or null if not found.
   */
  function extractPodcode(query) {
    const components = query.split(',').map((c) => c.trim());
    let postcode = null;
    for (const component of components) {
      const postcodeMatch = component.match(/(\d{4})(?=[,\s]|$)/);
      if (postcodeMatch) {
        postcode = postcodeMatch[1];
      }
    }
    if (!postcode) return null;
    const address = components
      .filter((component) => {
        return !(component.includes('Australia') || component.includes('Victoria') || component.includes('Melbourne'));
      })
      .join(', ');

    return { postcode, address };
  }

  /**
   * Extracts the label from the Nominatim API response.
   * @param {Object} data - The response data from the Nominatim API.
   * @returns {string | null} - The extracted label, or null if not found.
   */
  function extractNominatimLabel(data) {
    let label = null;
    for (const feature of data.features) {
      const type = /** @type {string | undefined} */ (feature.properties?.geocoding?.type);
      if (type === 'district' || type === 'locality' || type === 'state') {
        label = /** @type {string} */ (feature.properties?.geocoding?.label);
        if (!label) throw new Error('No label found');
        break;
      }
    }
    return label;
  }

  /**
   * Queries the Nominatim API for the given address.
   * @param {string} address - The address to query.
   * @returns {Promise<{ postcode: string; address: string }|null>} - The extracted postcode and address, or null if not found.
   */
  async function queryNominatim(address) {
    const query = encodeURIComponent(address);
    const url = `https://nominatim.openstreetmap.org/search?format=geocodejson&q=${query},+Victoria&countrycodes=au&limit=5`;
    const response = await fetch(url, { headers: HEADERS });
    if (!response.ok) {
      throw new Error(`HTTP error: ${response.status}`);
    }
    const data = await response.json();
    const label = extractNominatimLabel(data);
    if (!label) {
      return null;
    }
    return extractPodcode(label);
  }

  /** Logs a missing postcode to the Google Sheets spreadsheet.
   *
   * @param {string} postcode The postcode to log.
   */
  async function logMissingPostcode(postcode) {
    const url = `https://nominatim.openstreetmap.org/search?format=geocodejson&q=${postcode}&countrycodes=au&limit=5`;
    const response = await fetch(url, { headers: HEADERS });
    if (!response.ok) {
      throw new Error(`HTTP error: ${response.status}`);
    }
    const data = await response.json();
    const label = extractNominatimLabel(data);
    const encPostcode = encodeURIComponent(postcode);
    const address = encodeURIComponent(label ?? '');
    await fetch(
      'https://script.google.com/macros/s/AKfycbxKp4Oc-_NXQuoP4THu6Wrd8B1AbtXWLbcnKLrmHgxDwBzzJraSoP_B1X0JGjzzSdbe/exec',
      {
        method: 'POST',
        mode: 'no-cors',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: `postcode=${encPostcode}&address=${address}`,
      },
    ).catch(console.error);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["banner-ordering-guide"]) return;
  try {
    
// Section-Builder: 01-main.js
class OrderTracker extends HTMLElement {
    #progress = 0;
    #nodes;
    #trackFill;
    #segCount;
    #truckWrap;
    #popped = new Set();
    onScrollFn;

    constructor() {
      super();
      this.onScrollFn = this.#onScroll.bind(this);
      this.#nodes = Array.from(this.throw.any('[data-name="node"]'));
      this.#trackFill = this.throw.element('[data-name="track-fill"]');
      this.#truckWrap = this.throw.element('[data-name="truck-wrap"]');
      this.#segCount = this.#nodes.length - 1;
    }

    connectedCallback() {
      window.addEventListener('scroll', this.onScrollFn, { passive: true });
      window.addEventListener('resize', this.onScrollFn);
      this.onScrollFn();
    }

    disconnectedCallback() {
      window.removeEventListener('scroll', this.onScrollFn);
      window.removeEventListener('resize', this.onScrollFn);
    }

    #onScroll() {
      const rect = this.getBoundingClientRect();
      const start = window.innerHeight * 0.8;
      const end = window.innerHeight * 0.3;

      const raw = (start - rect.top) / (start - end);
      const clamped = Math.min(1, Math.max(0, raw));
      if (Math.abs(clamped - this.#progress) > 0.0005) {
        this.#progress = clamped;
        this.#update();
      }
    }

    #update() {
      const overall = this.#progress * this.#segCount; // 0..segCount
      const width = this.offsetWidth;
      const x = width * this.#progress;

      this.#trackFill.style.width = `${this.#progress * 100}%`;
      const trackWidth = this.#trackFill.offsetWidth;
      const truckWidth = this.#truckWrap.offsetWidth;
      this.#truckWrap.style.transform = `translateX(${trackWidth - truckWidth / 2}px)`;

      this.#nodes.forEach((node, i) => {
        const reached = overall >= i - 0.001;
        const isLast = i === this.#segCount;

        node.toggleAttribute('data-reached', reached);
        node.dataset.last = isLast ? 'true' : 'false';

        const check = node.throw.element('svg[data-name="check"]');

        if (reached) {
          // Determine if the checkmark should show & pop
          const showCheck = !isLast || overall >= this.#segCount - 0.001;

          if (showCheck) {
            if (!this.#popped.has(i)) {
              check.classList.add('pop-in');
              this.#popped.add(i);
            }
          } else {
            check.classList.remove('pop-in');
          }
        } else {
          check.classList.remove('pop-in');
          this.#popped.delete(i);
        }
      });
    }
  }

  customElements.define('order-tracker', OrderTracker);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["banner-scrolling-text"]) return;
  try {
    
// Section-Builder: 01-main.js
const SPEED = 0.4;

  class TextAutoScroller extends HTMLElement {
    #track;
    constructor() {
      super();
      this.#track = document.body.throw.element('[data-scroll-text]');
    }

    connectedCallback() {
      window.addEventListener(
        'scroll',
        () => {
          const offset = -(window.scrollY * SPEED) % this.#track.scrollWidth;
          this.#track.style.transform = `translateX(${offset}px)`;
        },
        { passive: true },
      );
    }
  }

  customElements.define('text-auto-scroller', TextAutoScroller);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cart-popup"]) return;
  try {
    
// Section-Builder: cart-popup.js
class CartPopup extends HTMLElement {
  /** @type {HTMLDialogElement} */
  #popup;
  #popupSurface;

  constructor() {
    super();
    this.#popup = /** @type {HTMLDialogElement} */ (
      this.throw.element("dialog")
    );
    this.#popupSurface = this.#popup.throw.element(
      '[data-name="popup-surface"]',
    );
  }

  startZapiet() {
    document.body.addEventListener(
      "hx:after-swap",
      () => {
        // @ts-ignore
        Zapiet.start(ZapietCachedSettings);
        setTimeout(() => {
          // @ts-ignore
          if (Zapiet.Widget.checkoutEnabled() === undefined) {
            // @ts-ignore
            Zapiet.start(ZapietCachedSettings);
          }
        }, 2000);
      },
      { once: true },
    );
  }

  /**
   * Prevents the popup from closing when the user cancels or pops the history state.
   * @param {Event} event - The cancel or popstate event.
   */
  #preventClose = (event) => {
    event.preventDefault();
    this.close();
  };

  open() {
    const element = this.#popup.querySelector("#cart-main-layout");
    const form = element instanceof HTMLFormElement ? element : null;
    if (form) {
      form.requestSubmit();
      this.startZapiet();
    }
    this.#popup.showModal();
    requestAnimationFrame(() => {
      this.#popupSurface.dataset.show = String(true);
    });
    history.pushState({ modal: true }, "", window.location.href);
    window.addEventListener("popstate", this.#preventClose);
    document.body.addEventListener("cancel", this.#preventClose);
  }

  close() {
    this.#popupSurface.dataset.show = String(false);
    this.#popupSurface.addEventListener(
      "transitionend",
      () => this.#popup.close(),
      { once: true },
    );
    window.removeEventListener("popstate", this.#preventClose);
    document.body.removeEventListener("cancel", this.#preventClose);
    // Only go back if there's a modal state
    if (history.state?.modal) {
      history.back();
    }
  }
}

customElements.define("cart-popup", CartPopup);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["christmas-hero"]) return;
  try {
    
// Section-Builder: carousel-strip.js
class CarouselStrip extends HTMLElement {
  /** @type {HTMLElement | null} */
  #track = null;

  /** @type {number} */
  #interval = 3000;

  /** @type {number} */
  #realCount = 0;

  /** @type {number} */
  #index = 1;

  /** @type {boolean} */
  #paused = false;

  /** @type {boolean} */
  #dragging = false;

  /** @type {number} */
  #startX = 0;

  /** @type {number} */
  #dragOffset = 0;

  /** @type {number | undefined} */
  #timer = undefined;

  /** @type {number | undefined} */
  #resumeTimer = undefined;

  connectedCallback() {
    this.#track = this.querySelector("[data-track]");
    if (!this.#track) return;

    this.#interval = parseInt(this.dataset.interval || "3000", 10);
    this.#realCount = this.#track.children.length;

    const first = /** @type {Element} */ (this.#track.children[0]).cloneNode(
      true,
    );
    const last = /** @type {Element} */ (
      this.#track.children[this.#realCount - 1]
    ).cloneNode(true);
    this.#track.appendChild(first);
    this.#track.insertBefore(last, this.#track.children[0]);

    this.#index = 1;
    this.#paused = false;
    this.#dragging = false;
    this.#startX = 0;
    this.#dragOffset = 0;

    this.#setupTrack();
    this.#bindEvents();
    this.#resetAutoplay();
  }

  disconnectedCallback() {
    clearInterval(this.#timer);
    clearTimeout(this.#resumeTimer);
    this.#unbindEvents();
  }

  /** @returns {HTMLElement} */
  get #trackEl() {
    return /** @type {HTMLElement} */ (this.#track);
  }

  /** @returns {number} */
  get #slideWidth() {
    return this.getBoundingClientRect().width;
  }

  #setupTrack = () => {
    this.#trackEl.style.willChange = "transform";
    this.#jumpTo(this.#index, false);
  };

  /**
   * @param {number} index
   * @param {boolean} [animate=true]
   */
  #jumpTo = (index, animate = true) => {
    this.#trackEl.style.transition = animate ? "transform 400ms ease" : "none";
    this.#trackEl.style.transform = `translate3d(${-index * this.#slideWidth}px, 0, 0)`;
  };

  #next = () => {
    if (this.#dragging) return;
    this.#index++;
    this.#jumpTo(this.#index, true);

    if (this.#index === this.#trackEl.children.length - 1) {
      this.#trackEl.addEventListener(
        "transitionend",
        () => {
          this.#index = 1;
          this.#jumpTo(this.#index, false);
        },
        { once: true },
      );
    }
  };

  #resetAutoplay = () => {
    clearInterval(this.#timer);
    if (!this.#paused) {
      this.#timer = window.setInterval(this.#next, this.#interval);
    }
  };

  #pauseThenResume = () => {
    this.#paused = true;
    clearInterval(this.#timer);
    clearTimeout(this.#resumeTimer);
    this.#resumeTimer = window.setTimeout(() => {
      this.#paused = false;
      this.#resetAutoplay();
    }, this.#interval);
  };

  /**
   * @param {PointerEvent} e
   */
  #handlePointerDown = (e) => {
    e.preventDefault();
    this.#dragging = true;
    this.#paused = true;
    clearInterval(this.#timer);
    this.#startX = e.clientX;
    this.#trackEl.style.transition = "none";
    this.style.cursor = "grabbing";
    this.setPointerCapture(e.pointerId);
  };

  /**
   * @param {PointerEvent} e
   */
  #handlePointerMove = (e) => {
    if (!this.#dragging) return;
    this.#dragOffset = e.clientX - this.#startX;
    const base = -this.#index * this.#slideWidth;
    this.#trackEl.style.transform = `translate3d(${base + this.#dragOffset}px, 0, 0)`;
  };

  #handlePointerEnd = () => {
    if (!this.#dragging) return;
    this.#dragging = false;
    this.style.cursor = "grab";

    const threshold = this.#slideWidth * 0.2;
    if (this.#dragOffset < -threshold) {
      this.#index++;
    } else if (this.#dragOffset > threshold) {
      this.#index--;
    }
    this.#dragOffset = 0;
    this.#jumpTo(this.#index, true);

    const lastIdx = this.#trackEl.children.length - 1;
    if (this.#index === lastIdx) {
      this.#trackEl.addEventListener(
        "transitionend",
        () => {
          this.#index = 1;
          this.#jumpTo(this.#index, false);
        },
        { once: true },
      );
    } else if (this.#index === 0) {
      this.#trackEl.addEventListener(
        "transitionend",
        () => {
          this.#index = this.#realCount;
          this.#jumpTo(this.#index, false);
        },
        { once: true },
      );
    }

    this.#pauseThenResume();
  };

  #handleMouseEnter = () => {
    this.#paused = true;
    clearInterval(this.#timer);
  };

  #handleMouseLeave = () => {
    this.#paused = false;
    this.#resetAutoplay();
  };

  #handleResize = () => {
    this.#jumpTo(this.#index, false);
  };

  #bindEvents = () => {
    this.addEventListener("mouseenter", this.#handleMouseEnter);
    this.addEventListener("mouseleave", this.#handleMouseLeave);
    this.addEventListener("pointerdown", this.#handlePointerDown);
    this.addEventListener("pointermove", this.#handlePointerMove);
    this.addEventListener("pointerup", this.#handlePointerEnd);
    this.addEventListener("pointercancel", this.#handlePointerEnd);
    this.addEventListener("pointerleave", this.#handlePointerEnd);
    window.addEventListener("resize", this.#handleResize);
  };

  #unbindEvents = () => {
    this.removeEventListener("mouseenter", this.#handleMouseEnter);
    this.removeEventListener("mouseleave", this.#handleMouseLeave);
    this.removeEventListener("pointerdown", this.#handlePointerDown);
    this.removeEventListener("pointermove", this.#handlePointerMove);
    this.removeEventListener("pointerup", this.#handlePointerEnd);
    this.removeEventListener("pointercancel", this.#handlePointerEnd);
    this.removeEventListener("pointerleave", this.#handlePointerEnd);
    window.removeEventListener("resize", this.#handleResize);
  };
}

customElements.define("carousel-strip", CarouselStrip);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["christmas-santa"]) return;
  try {
    
// Section-Builder: santa-fly.js
class SantaFly extends HTMLElement {
  #progress = 0; // 0 = start of flight, 1 = end (then resets to 0)
  #lastScrollY = 0;
  #santa;
  #container;
  #ticking = false;
  onScrollFn;

  // tweak these to taste
  #minScale = 0.55; // size at the ends of the flight
  #maxScale = 1; //    size at the top of the arc

  constructor() {
    super();
    this.onScrollFn = this.#onScroll.bind(this);
  }

  connectedCallback() {
    // Query children here, not in the constructor: the constructor can run
    // before the element's children have been parsed.
    this.#santa =
      this.querySelector('[data-name="hand"]') ?? this.firstElementChild;
    const selector = this.getAttribute("container");
    this.#container =
      (selector && this.closest(selector)) || this.parentElement;

    if (this.#santa) this.#santa.style.willChange = "transform";

    this.#lastScrollY = window.scrollY;
    this.#progress = 0;

    window.addEventListener("scroll", this.onScrollFn, { passive: true });
    window.addEventListener("resize", this.onScrollFn);
    this.onScrollFn();
  }

  disconnectedCallback() {
    window.removeEventListener("scroll", this.onScrollFn);
    window.removeEventListener("resize", this.onScrollFn);
  }

  // Height of the full 0-180 degree arc as a multiple of Santa's own width.
  // Santa is what the eye measures the arc against, so tying the height to
  // him keeps the hump looking the same however wide the screen (and the
  // flight path) gets. 0.6 = the full arc is 60% as tall as Santa is wide.
  get #arcRatio() {
    const v = parseFloat(this.getAttribute("arc-ratio"));
    return Number.isFinite(v) ? v : 0.6;
  }

  get #tilt() {
    const v = parseFloat(this.getAttribute("tilt"));
    return Number.isFinite(v) ? v : 0.6;
  }

  // Which slice of the half-circle arc (0 = left end, 90 = peak, 180 = right
  // end) Santa actually flies. Default 60 -> 120 is a shallow hump around the
  // peak. Use arc-start="0" arc-end="180" for the old full arc.
  get #arcStart() {
    const v = parseFloat(this.getAttribute("arc-start"));
    return Number.isFinite(v) ? v : 60;
  }

  get #arcEnd() {
    const v = parseFloat(this.getAttribute("arc-end"));
    return Number.isFinite(v) ? v : 120;
  }

  // How fast scrolling pushes him across (1 = one full flight per
  // viewport-height-plus-container of scrolling, same pace as before).
  get #speed() {
    const v = parseFloat(this.getAttribute("speed"));
    return Number.isFinite(v) && v > 0 ? v : 1;
  }

  #onScroll() {
    if (this.#ticking) return;
    this.#ticking = true;
    requestAnimationFrame(() => {
      this.#measure();
      this.#ticking = false;
    });
  }

  #measure() {
    if (!this.#santa || !this.#container) return;

    const rect = this.#container.getBoundingClientRect();
    const vh = window.innerHeight;

    // Santa always flies the same way, no matter which way you scroll: any
    // scrolling (up or down) pushes him forward. Only advance while the
    // container is on screen.
    const y = window.scrollY;
    const delta = Math.abs(y - this.#lastScrollY);
    this.#lastScrollY = y;

    const inView = rect.bottom > 0 && rect.top < vh;
    if (delta > 0 && inView) {
      this.#progress += (delta / (vh + rect.height)) * this.#speed;
      // Reached the end: snap back to the start.
      if (this.#progress >= 1) this.#progress = 0;
    }

    this.#update(rect);
  }

  #update(containerRect) {
    const p = this.#progress;

    // Host element is never transformed, so its rect is Santa's "natural"
    // position. We assume the hand is centred in the host.
    const hostRect = this.getBoundingClientRect();
    const hostCenterX = hostRect.left + hostRect.width / 2;
    // NOTE: don't use hand.offsetWidth – it's undefined on <svg> elements.
    // The host is sized by its (untransformed) content, so use its width.
    const halfHand = hostRect.width / 2;

    // Angle along the arc for this progress, in radians.
    const a0 = this.#arcStart;
    const a1 = this.#arcEnd;
    const theta = ((a0 + p * (a1 - a0)) * Math.PI) / 180;
    const sin = Math.sin(theta);

    // Slightly larger at the peak, smaller at the ends (adds depth).
    // Normalised so the ends of the chosen slice are always minScale.
    const sinEnds = Math.min(
      Math.sin((a0 * Math.PI) / 180),
      Math.sin((a1 * Math.PI) / 180),
    );
    const depth = sinEnds < 1 ? (sin - sinEnds) / (1 - sinEnds) : 1;
    const scale =
      this.#minScale + Math.max(0, depth) * (this.#maxScale - this.#minScale);

    // Horizontal: right-most centre -> left-most centre of the container,
    // using the *scaled* half-width so Santa stays inside the edges.
    const leftX = containerRect.left + halfHand * this.#minScale - hostCenterX;
    const rightX =
      containerRect.right - halfHand * this.#minScale - hostCenterX;
    const x = rightX + p * (leftX - rightX);

    // Vertical: sine arc. 0 at the peak (90deg), +H at 0/180deg. H is tied
    // to Santa's width (not the screen width) so the hump keeps the same
    // size relative to him on every screen.
    const travel = Math.abs(rightX - leftX) || 1;
    const H = hostRect.width * this.#arcRatio;
    const y = H * (1 - sin);

    // Bank along the path: angle of the tangent (dy/dx).
    // Travel is right-to-left, so measure the slope against the distance
    // covered leftwards: nose dips while descending, lifts while climbing.
    const dx = travel;
    const dy = (-H * Math.cos(theta) * ((a1 - a0) * Math.PI)) / 180;
    const angle = Math.atan2(-dy, dx) * (180 / Math.PI) * this.#tilt;

    this.#santa.style.transform = `translate3d(${x}px, ${y}px, 0) rotate(${angle}deg) scale(${scale})`;
  }
}

customElements.define("santa-fly", SantaFly);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["christmas-snowflakes"]) return;
  try {
    
// Section-Builder: snowfall.js
class SnowFall extends HTMLElement {
  static observedAttributes = ["target", "to", "rate", "color"];

  static #MAX_DPR = 1.5; // soft dots don't need full retina; big win on phones
  static #MAX_FLAKES = 1500;
  static #AVG_VY = 23; // mean fall speed (px/s), matches #spawn
  static #FADE_ZONE = 120;

  /** @type {HTMLCanvasElement | null} */
  #canvas = null;
  /** @type {CanvasRenderingContext2D | null | undefined} */
  #ctx = null;
  /** @type {Element | null} */
  #target = null;
  /** @type {Array<{x: number, y: number, r: number, vy: number, sway: number, freq: number, phase: number, alpha: number}>} */
  #flakes = [];
  #raf = 0;
  #last = 0;
  #spawnDebt = 0;
  #layoutQueued = false;
  /** @type {ResizeObserver | null} */
  #ro = null;
  /** @type {MediaQueryList} */
  #reduced = matchMedia("(prefers-reduced-motion: reduce)");

  // Snow region (CSS px). Flakes live in region-local coordinates.
  #w = 0;
  #h = 0;
  #pageTop = 0; // region top in page coordinates

  // Canvas backing size (CSS px). Viewport-sized, only ever grows.
  #cssW = 0;
  #cssH = 0;
  #dpr = 1;

  #rate = 6;
  #color = "#fff";

  connectedCallback() {
    this.#canvas ??= this.querySelector("canvas");
    this.#ctx ??= this.#canvas?.getContext("2d");

    this.#ro = new ResizeObserver(() => this.#queueLayout());
    this.#ro.observe(document.documentElement);
    this.#ro.observe(document.body);
    addEventListener("resize", this.#queueLayout);
    document.addEventListener("visibilitychange", this.#onVisibility);
    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", () => this.#resolve(), {
        once: true,
      });
    } else {
      this.#resolve();
    }
  }

  disconnectedCallback() {
    this.#stop();
    this.#ro?.disconnect();
    removeEventListener("resize", this.#queueLayout);
    document.removeEventListener("visibilitychange", this.#onVisibility);
  }

  attributeChangedCallback() {
    if (this.isConnected) this.#resolve();
  }

  #queueLayout = () => {
    if (this.#layoutQueued) return;
    this.#layoutQueued = true;
    requestAnimationFrame(() => {
      this.#layoutQueued = false;
      this.#layout();
    });
  };

  #onVisibility = () => {
    document.hidden ? this.#stop() : this.#start();
  };

  #resolve() {
    const sel = this.getAttribute("target");
    this.#target = sel ? document.querySelector(sel) : null;
    if (!this.#target) {
      this.#stop();
      throw new Error(`[Snowfall]: no element matches target: ${sel}`);
    }
    this.#rate = parseFloat(this.getAttribute("rate") ?? "") || 6;
    this.#ro?.observe(this.#target);
    this.#layout();
    this.#start();
  }

  #refreshColor() {
    this.#color =
      this.getAttribute("color") ||
      getComputedStyle(this).getPropertyValue("--snow-color").trim() ||
      "#fff";
  }

  #layout() {
    if (!this.#target) return;
    const c = this.#canvas;
    if (!c) {
      throw new Error("[Snowfall]: Canvas is null");
    }

    const t = this.#target.getBoundingClientRect();
    const endSel = this.getAttribute("to");
    const endEl = endSel ? document.querySelector(endSel) : null;

    const pageTop = t.top + scrollY;
    const pageBottom = endEl
      ? endEl.getBoundingClientRect().bottom + scrollY
      : document.documentElement.scrollHeight;

    const w = Math.max(1, Math.round(t.width));
    const h = Math.max(1, Math.round(pageBottom - pageTop) - 1);
    const prevW = this.#w;
    const prevH = this.#h;
    this.#w = w;
    this.#h = h;
    this.#pageTop = pageTop;

    // The canvas only covers the viewport (not the whole page) and never
    // shrinks, so the mobile URL bar collapsing doesn't reallocate it.
    const dpr = Math.min(devicePixelRatio || 1, SnowFall.#MAX_DPR);
    const cssH = Math.max(innerHeight, this.#cssH);
    if (w !== this.#cssW || cssH !== this.#cssH || dpr !== this.#dpr) {
      this.#cssW = w;
      this.#cssH = cssH;
      this.#dpr = dpr;
      c.style.width = w + "px";
      c.style.height = cssH + "px";
      c.width = Math.round(w * dpr);
      c.height = Math.round(cssH * dpr);
      this.#ctx?.setTransform(dpr, 0, 0, dpr, 0, 0);
    }

    // Pin the canvas to the viewport at the target's horizontal position,
    // regardless of the containing block.
    c.style.position = "fixed";
    c.style.pointerEvents = "none";
    c.style.left = "0px";
    c.style.top = "0px";
    const origin = c.getBoundingClientRect();
    c.style.left = t.left - origin.left + "px";
    c.style.top = -origin.top + "px";

    this.#refreshColor();

    // Full sky on first layout / width change / newly added height.
    if (w !== prevW) {
      this.#flakes = [];
      this.#prefill(0, h);
    } else if (h > prevH) {
      this.#prefill(prevH, h);
    }
  }

  /**
   * @param {number} fromY
   * @param {number} toY
   */
  #prefill(fromY, toY) {
    const count = Math.round(
      this.#rate * (this.#w / 1000) * ((toY - fromY) / SnowFall.#AVG_VY),
    );
    const room = Math.max(0, SnowFall.#MAX_FLAKES - this.#flakes.length);
    this.#spawn(Math.min(count, room), fromY, toY);
  }

  /**
   * @param {number} count
   * @param {number} [fromY=-4]
   * @param {number} [toY=-4]
   */
  #spawn(count, fromY = -4, toY = -4) {
    for (let i = 0; i < count; i++) {
      this.#flakes.push({
        x: Math.random() * this.#w,
        y: fromY + Math.random() * (toY - fromY),
        r: 0.8 + Math.random() * 2.2,
        vy: 12 + Math.random() * 22, // px/s, lazy
        sway: 6 + Math.random() * 16, // px amplitude
        freq: 0.3 + Math.random() * 0.6, // rad/s
        phase: Math.random() * Math.PI * 2,
        alpha: 0.4 + Math.random() * 0.6,
      });
    }
  }

  #start() {
    if (this.#raf || this.#reduced.matches || !this.#target) return;
    this.#last = performance.now();
    this.#raf = requestAnimationFrame(this.#tick);
  }

  #stop() {
    cancelAnimationFrame(this.#raf);
    this.#raf = 0;
  }

  /** @param {number} now */
  #tick = (now) => {
    const dt = Math.min((now - this.#last) / 1000, 0.1);
    this.#last = now;
    this.#update(dt);
    this.#draw();
    this.#raf = requestAnimationFrame(this.#tick);
  };

  /** @param {number} dt - Delta time in seconds. */
  #update(dt) {
    this.#spawnDebt += this.#rate * (this.#w / 1000) * dt;
    const n = Math.floor(this.#spawnDebt);
    this.#spawnDebt -= n;
    if (this.#flakes.length < SnowFall.#MAX_FLAKES) this.#spawn(n);

    // Update and compact in place (no per-frame array allocation).
    const flakes = this.#flakes;
    const limit = this.#h + 4;
    let j = 0;
    for (let i = 0; i < flakes.length; i++) {
      const f = flakes[i];
      f.y += f.vy * dt;
      f.phase += f.freq * dt;
      if (f.y < limit) flakes[j++] = f;
    }
    flakes.length = j;
  }

  #draw() {
    const ctx = this.#ctx;
    if (!ctx) {
      throw new Error("[Snowflake]: ctx is null");
    }

    ctx.clearRect(0, 0, this.#cssW, this.#cssH);

    // Region-local y of the viewport's top edge; only draw what's on screen.
    const vh = innerHeight;
    const top = scrollY - this.#pageTop;
    if (top > this.#h + 4 || top + vh < -4) return;

    ctx.fillStyle = this.#color;
    const h = this.#h;
    const fadeZone = SnowFall.#FADE_ZONE;
    for (const f of this.#flakes) {
      const y = f.y - top;
      if (y < -4 || y > vh + 4) continue;
      const fade = Math.min(1, (h - f.y) / fadeZone);
      if (fade <= 0) continue;
      ctx.globalAlpha = f.alpha * fade;
      ctx.beginPath();
      ctx.arc(f.x + Math.sin(f.phase) * f.sway, y, f.r, 0, Math.PI * 2);
      ctx.fill();
    }
    ctx.globalAlpha = 1;
  }
}

customElements.define("snow-fall", SnowFall);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["halloween-ghosts"]) return;
  try {
    
// Section-Builder: scroll-fade.js
/**
 * A web component that fades out all child SVGs when the user scrolls down,
 * then slowly restores their opacity over time.
 *
 * @example
 * <scroll-fade fade-distance="400" recover-time="5">
 *   <svg viewBox="0 0 100 100"><circle cx="50" cy="50" r="40" /></svg>
 * </scroll-fade>
 *
 * @attr {number} [fade-distance=400] Pixels scrolled down to go from fully visible to invisible.
 * @attr {number} [recover-time=5] Seconds to go from invisible back to fully visible.
 */
class ScrollFade extends HTMLElement {
  /** Current opacity of the SVG, between 0 and 1. @type {number} */
  #opacity = 1;

  /** Vertical scroll position at the previous scroll event. @type {number} */
  #lastScrollY = 0;

  /** Timestamp (ms) of the previous recovery frame. @type {number} */
  #lastTime = 0;

  /** Active requestAnimationFrame id, or null when recovery is idle. @type {number | null} */
  #rafId = null;

  /**
   * Pixels of downward scrolling that take the SVG from opaque to transparent.
   * @type {number}
   */
  get #fadeDistance() {
    return parseFloat(this.getAttribute("fade-distance") ?? "") || 400;
  }

  /**
   * Seconds the SVG takes to recover from transparent to opaque.
   * @type {number}
   */
  get #recoverTime() {
    return parseFloat(this.getAttribute("recover-time") ?? "") || 5;
  }

  /**
   * Every SVG element inside this component (e.g. separate mobile/desktop SVGs).
   * @type {NodeListOf<SVGSVGElement>}
   */
  get #svgs() {
    return this.querySelectorAll("svg");
  }

  /** @returns {void} */
  connectedCallback() {
    this.#lastScrollY = window.scrollY;
    window.addEventListener("scroll", this.#onScroll, { passive: true });
  }

  /** @returns {void} */
  disconnectedCallback() {
    window.removeEventListener("scroll", this.#onScroll);
    this.#stopRecovery();
  }

  /**
   * Fades the SVG proportionally to how far the user scrolled down.
   * Scrolling up has no effect.
   * @type {() => void}
   */
  #onScroll = () => {
    const currentY = window.scrollY;
    const delta = currentY - this.#lastScrollY;
    this.#lastScrollY = currentY;

    if (delta > 0) {
      this.#setOpacity(this.#opacity - delta / this.#fadeDistance);
      this.#startRecovery();
    }
  };

  /**
   * Starts the recovery animation loop if it isn't already running.
   * @returns {void}
   */
  #startRecovery() {
    if (this.#rafId !== null) return;
    this.#lastTime = performance.now();
    this.#rafId = requestAnimationFrame(this.#recoverStep);
  }

  /**
   * Cancels the recovery animation loop.
   * @returns {void}
   */
  #stopRecovery() {
    if (this.#rafId !== null) {
      cancelAnimationFrame(this.#rafId);
      this.#rafId = null;
    }
  }

  /**
   * One frame of the recovery loop. Raises opacity based on elapsed time and
   * stops itself once the SVG is fully visible.
   * @param {DOMHighResTimeStamp} now Timestamp provided by requestAnimationFrame.
   * @returns {void}
   */
  #recoverStep = (now) => {
    const dt = (now - this.#lastTime) / 1000;
    this.#lastTime = now;

    this.#setOpacity(this.#opacity + dt / this.#recoverTime);

    if (this.#opacity < 1) {
      this.#rafId = requestAnimationFrame(this.#recoverStep);
    } else {
      this.#rafId = null;
    }
  };

  /**
   * Clamps the value to [0, 1], stores it, and applies it to every SVG.
   * @param {number} value Desired opacity.
   * @returns {void}
   */
  #setOpacity(value) {
    this.#opacity = Math.min(1, Math.max(0, value));
    for (const svg of this.#svgs) svg.style.opacity = String(this.#opacity);
  }
}

customElements.define("scroll-fade", ScrollFade);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["halloween-graveyard"]) return;
  try {
    
// Section-Builder: hand-animation.js
class GraveHand extends HTMLElement {
  #progress = 0;
  #hand;
  #ticking = false;
  onScrollFn;

  // tweak these to taste
  #minScale = 0.55;
  #maxScale = 1;

  constructor() {
    super();
    this.onScrollFn = this.#onScroll.bind(this);
    this.#hand = this.querySelector('[data-name="hand"]');
  }

  connectedCallback() {
    window.addEventListener("scroll", this.onScrollFn, { passive: true });
    window.addEventListener("resize", this.onScrollFn);
    this.onScrollFn();
  }

  disconnectedCallback() {
    window.removeEventListener("scroll", this.onScrollFn);
    window.removeEventListener("resize", this.onScrollFn);
  }

  #onScroll() {
    if (this.#ticking) return;
    this.#ticking = true;
    requestAnimationFrame(() => {
      this.#measure();
      this.#ticking = false;
    });
  }

  #measure() {
    const rect = this.getBoundingClientRect();
    const start = window.innerHeight * 0.9;
    const end = window.innerHeight * 0.3;

    const raw = (start - rect.top) / (start - end);
    const clamped = Math.min(1, Math.max(0, raw));

    if (Math.abs(clamped - this.#progress) > 0.0005) {
      this.#progress = clamped;
      this.#update();
    }
  }

  #update() {
    // 50% -> 0% as progress goes 0 -> 1
    const translateY = 50 - this.#progress * 40;
    // minScale -> maxScale as progress goes 0 -> 1
    const scale =
      this.#minScale + this.#progress * (this.#maxScale - this.#minScale);

    this.#hand.style.transform = `translateY(${translateY}%) scale(${scale})`;
  }
}

customElements.define("grave-hand", GraveHand);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["halloween-hero"]) return;
  try {
    
// Section-Builder: 01-carousel-strip.js
// ---------------------------------------------------------------------------
// Carousel Strip
// ---------------------------------------------------------------------------

class CarouselStrip extends HTMLElement {
  connectedCallback() {
    this.track = this.querySelector("[data-track]");
    this.interval = parseInt(this.dataset.interval || "3000", 10);

    // real slide count (before cloning)
    this.realCount = this.track.children.length;

    // clone first and last slide for seamless infinite wrap
    const first = this.track.children[0].cloneNode(true);
    const last = this.track.children[this.realCount - 1].cloneNode(true);
    this.track.appendChild(first);
    this.track.insertBefore(last, this.track.children[0]);

    // index 1 = first real slide (index 0 is the cloned "last")
    this.index = 1;
    this.paused = false;
    this.dragging = false;
    this.startX = 0;
    this.dragOffset = 0;

    this._setupTrack();
    this._bindEvents();
    this._resetAutoplay();

    window.addEventListener("resize", () => this._jumpTo(this.index, false));
  }

  disconnectedCallback() {
    clearInterval(this._timer);
    clearTimeout(this._resumeTimer);
  }

  _setupTrack() {
    this.track.style.willChange = "transform";
    this._jumpTo(this.index, false);
  }

  get slideWidth() {
    return this.getBoundingClientRect().width;
  }

  _jumpTo(index, animate = true) {
    this.track.style.transition = animate ? "transform 400ms ease" : "none";
    this.track.style.transform = `translate3d(${-index * this.slideWidth}px, 0, 0)`;
  }

  _next() {
    if (this.dragging) return;
    this.index++;
    this._jumpTo(this.index, true);

    // if we've landed on the cloned last slide, snap back invisibly
    if (this.index === this.track.children.length - 1) {
      this.track.addEventListener(
        "transitionend",
        () => {
          this.index = 1;
          this._jumpTo(this.index, false);
        },
        { once: true },
      );
    }
  }

  _resetAutoplay() {
    clearInterval(this._timer);
    if (!this.paused) {
      this._timer = setInterval(() => this._next(), this.interval);
    }
  }

  _pauseThenResume() {
    this.paused = true;
    clearInterval(this._timer);
    clearTimeout(this._resumeTimer);
    this._resumeTimer = setTimeout(() => {
      this.paused = false;
      this._resetAutoplay();
    }, this.interval);
  }

  _bindEvents() {
    this.addEventListener("mouseenter", () => {
      this.paused = true;
      clearInterval(this._timer);
    });
    this.addEventListener("mouseleave", () => {
      this.paused = false;
      this._resetAutoplay();
    });

    this.addEventListener("pointerdown", (e) => {
      e.preventDefault();
      this.dragging = true;
      this.paused = true;
      clearInterval(this._timer);
      this.startX = e.clientX;
      this.track.style.transition = "none";
      this.style.cursor = "grabbing";
      this.setPointerCapture(e.pointerId);
    });

    this.addEventListener("pointermove", (e) => {
      if (!this.dragging) return;
      this.dragOffset = e.clientX - this.startX;
      const base = -this.index * this.slideWidth;
      this.track.style.transform = `translate3d(${base + this.dragOffset}px, 0, 0)`;
    });

    const endDrag = () => {
      if (!this.dragging) return;
      this.dragging = false;
      this.style.cursor = "grab";

      const threshold = this.slideWidth * 0.2;
      if (this.dragOffset < -threshold) {
        this.index++;
      } else if (this.dragOffset > threshold) {
        this.index--;
      }
      this.dragOffset = 0;
      this._jumpTo(this.index, true);

      // handle wrap-around after manual swipe
      const lastIdx = this.track.children.length - 1;
      if (this.index === lastIdx) {
        this.track.addEventListener(
          "transitionend",
          () => {
            this.index = 1;
            this._jumpTo(this.index, false);
          },
          { once: true },
        );
      } else if (this.index === 0) {
        this.track.addEventListener(
          "transitionend",
          () => {
            this.index = this.realCount;
            this._jumpTo(this.index, false);
          },
          { once: true },
        );
      }

      this._pauseThenResume();
    };

    this.addEventListener("pointerup", endDrag);
    this.addEventListener("pointercancel", endDrag);
    this.addEventListener("pointerleave", endDrag);
  }
}

customElements.define("carousel-strip", CarouselStrip);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-announcement-bar"]) return;
  try {
    
// Section-Builder: 01-main.js
const ANNOUCEMENT_SPEED = 'data-speed';

  class AnnouncementBar extends HTMLElement {
    DURATION = 700;
    EASING = 'cubic-bezier(0.86, 0, 0.07, 1)';

    #track;
    #current = 0;
    #interval = 1000;
    #slides = [];

    constructor() {
      super();
      this.#track = this.throw.element("[data-name='track']");
    }

    connectedCallback() {
      const clone = this.#track.throw.element('[data-name="announcement"]').cloneNode(true);
      this.#track.appendChild(clone);
      this.#slides = Array.from(this.#track.throw.any('[data-name="announcement"]'));

      const transition_speed = this.getAttribute(ANNOUCEMENT_SPEED);
      if (transition_speed) {
        this.#interval = parseInt(transition_speed) * 1000;
      }

      setInterval(() => this.advance(), this.#interval);
    }
    /**
     * Enable or disable transition on the track element
     * @param {boolean} enabled - Whether to enable (true) or disable (false) transition
     */
    setTransition(enabled) {
      this.#track.style.transition = enabled ? `transform ${this.DURATION}ms ${this.EASING}` : 'none';
    }
    advance() {
      this.#current++;

      this.setTransition(true);
      this.#track.style.transform = `translateY(-${(this.#current * 100) / this.#slides.length}%)`;

      // Once animated into the clone, snap back to real slide 0
      if (this.#current === this.#slides.length - 1) {
        setTimeout(() => {
          this.setTransition(false);
          this.#track.style.transform = 'translateY(0%)';
          this.#current = 0;
        }, this.DURATION);
      }
    }
  }

  customElements.define('announcement-bar', AnnouncementBar);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-geolocator"]) return;
  try {
    
// Section-Builder: geolocate.js
class GeoPopup extends HTMLElement {
  #endpoint = "https://ipgeolocator.wilymonkey.dev";
  #storageKey = "ip-geolocator:choice-made";
  #dialog;
  /** @type {Map<string, string>} */
  #urlMap = new Map();

  constructor() {
    super();
    this.#dialog = /** @type {HTMLDialogElement} */ (
      this.throw.element("dialog")
    );
    this.throw.any("[data-url][data-id]").forEach((element) => {
      const id = element.dataset.id;
      const url = element.dataset.url;
      if (!id || !url) {
        throw Error(`[IP-Geolocator]: ID: ${id} and/or ${url} is invalid`);
      }

      this.#urlMap.set(id, url);
    });
  }

  connectedCallback() {
    // The user already made a choice (or never needed the dialog): skip the IP lookup entirely.
    if (this.hasMadeChoice()) return;
    this.fetchGeoInfo();
  }

  /**
   * RETRIEVE: has the user already made a choice about which store to use?
   * @returns {boolean}
   */
  hasMadeChoice() {
    try {
      return localStorage.getItem(this.#storageKey) === "true";
    } catch (err) {
      // localStorage can be blocked (private mode, etc.). Treat as "no choice yet".
      console.error(`[IP-Geolocator]: could not read choice: ${err}`);
      return false;
    }
  }

  /**
   * STORE: remember that the user made a choice (or that no dialog was needed).
   */
  saveChoice() {
    try {
      localStorage.setItem(this.#storageKey, "true");
    } catch (err) {
      console.error(`[IP-Geolocator]: could not save choice: ${err}`);
    }
  }

  /**
   * @param {string} state
   * @returns {string | null} the url the user should be directed to, or null if they're already in the right store.
   */
  redirectTo(state) {
    const current = window.location.hostname;
    const target = this.#urlMap.get(state);
    if (!target) {
      throw Error(`[IP-Geolocator]: State ${state} is not in #urlMap`);
    }

    if (target !== current) {
      return "https://" + target;
    }
    return null;
  }

  async fetchGeoInfo() {
    let state;
    try {
      const res = await fetch(this.#endpoint);
      if (!res.ok) throw Error(`HTTP ${res.status}`);
      state = (await res.text()).trim();
    } catch (err) {
      // Lookup failed: don't save anything so we can try again next visit.
      console.error(`[IP-Geolocator]: ${err}`);
      return;
    }

    // No usable location: nothing to act on, and nothing worth remembering.
    if (!state || state === "MISS") return;

    let url = this.redirectTo(state);
    if (!url) {
      // User is already in the correct store, no dialog needed.
      this.saveChoice();
      return;
    }

    this.dispatchEvent(
      new CustomEvent("geo-resolved", {
        detail: { location: state, url },
        bubbles: true,
      }),
    );
    this.handleOpen();
  }

  /**
   * @param {Event} event - The cancel or popstate event.
   */
  #preventClose = (event) => {
    event.preventDefault();
    this.handleClose();
  };

  /**
   * @param {Event} event
   */
  #onDialogClick = (event) => {
    if (event.target === this.#dialog) {
      this.handleClose();
    }
  };

  handleOpen() {
    this.#dialog.showModal();
    history.pushState({ modal: true }, "", window.location.href);
    window.addEventListener("popstate", this.#preventClose);
    document.body.addEventListener("cancel", this.#preventClose);
    this.#dialog.addEventListener("click", this.#onDialogClick);
  }

  handleClose() {
    this.#dialog.close();
    window.removeEventListener("popstate", this.#preventClose);
    document.body.removeEventListener("cancel", this.#preventClose);
    this.#dialog.removeEventListener("click", this.#onDialogClick);

    // The user interacted with the dialog, so don't ask again.
    this.saveChoice();

    // Only go back if there's a modal state
    if (history.state?.modal) {
      history.back();
    }
  }
}

customElements.define("geo-popup", GeoPopup);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-navbar-drawer"]) return;
  try {
    
// Section-Builder: 01-main.js
class NavbarDrawer extends HTMLElement {
    #popup;
    #popupSurface;
    #boundPreventClose; // Store the bound version so we can remove it later

    constructor() {
      super();
      this.#popup = /** @type {HTMLDialogElement} */ (this.throw.element('dialog'));
      this.#popupSurface = this.throw.element('[data-name="popup-surface"]');

      // Fix: Force 'this' to always refer to the NavbarDrawer instance
      this.#boundPreventClose = this.#preventClose.bind(this);
    }

    open() {
      this.#popup.showModal();
      requestAnimationFrame(() => {
        this.#popupSurface.setAttribute('data-show', '');
      });

      // Push the state so the back button closes the drawer instead of leaving the page
      history.pushState({ modal: true }, '', window.location.href);

      // Use the bound version here
      window.addEventListener('popstate', this.#boundPreventClose);
      document.body.addEventListener('cancel', this.#boundPreventClose);
    }

    /** Prevents the popup from closing when the user cancels or pops the history state.
     *
     * @param {Event} event - The cancel or popstate event.
     */
    #preventClose(event) {
      event.preventDefault();
      this.close();
    }

    close() {
      this.#popupSurface.removeAttribute('data-show');
      this.#popupSurface.addEventListener('transitionend', () => this.#popup.close(), {
        once: true,
      });

      // Use the bound version here to successfully clean up
      window.removeEventListener('popstate', this.#boundPreventClose);
      document.body.removeEventListener('cancel', this.#boundPreventClose);

      // Only go back if there's an active modal state left in history
      if (history.state?.modal) {
        history.back();
      }
    }
  }

  customElements.define('navbar-drawer', NavbarDrawer);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-navbar"]) return;
  try {
    
// Section-Builder: header-search.js
class HeaderSearch extends HTMLElement {
  #popup;
  #dismissBtn;
  #popupSurface;
  #historyEntryPushed = false;

  constructor() {
    super();
    this.#popup = /** @type {HTMLDialogElement} */ (
      this.throw.element("dialog")
    );
    this.#popupSurface = this.throw.element('[data-name="popup-surface"]');
    this.#dismissBtn = this.throw.element('[data-name="dismiss-search"]');
  }

  open() {
    this.#popup.show();
    const { scrollX, scrollY } = window;
    window.scrollTo({ left: scrollX, top: scrollY, behavior: "instant" });

    requestAnimationFrame(() => {
      this.#popupSurface.setAttribute("data-show", "");
    });
    this.#dismissBtn.toggleAttribute("data-show", true);

    // Push a sentinel history entry so "back" pops it instead of leaving the page.
    history.pushState({ headerSearchOpen: true }, "");
    this.#historyEntryPushed = true;

    window.addEventListener("popstate", this.#handlePopState);
    window.addEventListener("scroll", this.#handleScroll, { passive: true });
    this.#popup.addEventListener("cancel", this.#handleCancel);
  }

  /** Closes the popup when the main window is scrolled. */
  #handleScroll = () => {
    this.close();
  };

  /** Back button / history traversal: the sentinel entry is already gone,
   * so just close without touching history again. */
  #handlePopState = () => {
    this.#historyEntryPushed = false;
    this.close();
  };

  /** Escape key (dialog "cancel" event). We handle closing ourselves so the
   * exit transition runs and history stays in sync.
   *
   * @param {Event} event
   */
  #handleCancel = (event) => {
    event.preventDefault();
    this.close();
  };

  close() {
    // Make close() idempotent (scroll can fire many times).
    window.removeEventListener("popstate", this.#handlePopState);
    window.removeEventListener("scroll", this.#handleScroll);
    this.#popup.removeEventListener("cancel", this.#handleCancel);

    this.#popupSurface.removeAttribute("data-show");
    this.#popupSurface.addEventListener(
      "transitionend",
      () => {
        this.#popup.close();
      },
      { once: true },
    );
    this.#dismissBtn.toggleAttribute("data-show", false);

    // If we're closing by something other than back, remove the sentinel entry.
    // The popstate listener is already removed above, so this won't re-enter close().
    if (this.#historyEntryPushed) {
      this.#historyEntryPushed = false;
      if (history.state?.headerSearchOpen) {
        history.back();
      }
    }
  }
}

customElements.define("header-search", HeaderSearch);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-immersive-image"]) return;
  try {
    
// Section-Builder: 01-main.js
// ---------------------------------------------------------------------------
  // Carousel Strip
  // ---------------------------------------------------------------------------

  class CarouselStrip extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-track]');
      this.interval = parseInt(this.dataset.interval || '3000', 10);

      // real slide count (before cloning)
      this.realCount = this.track.children.length;

      // clone first and last slide for seamless infinite wrap
      const first = this.track.children[0].cloneNode(true);
      const last = this.track.children[this.realCount - 1].cloneNode(true);
      this.track.appendChild(first);
      this.track.insertBefore(last, this.track.children[0]);

      // index 1 = first real slide (index 0 is the cloned "last")
      this.index = 1;
      this.paused = false;
      this.dragging = false;
      this.startX = 0;
      this.dragOffset = 0;

      this._setupTrack();
      this._bindEvents();
      this._resetAutoplay();

      window.addEventListener('resize', () => this._jumpTo(this.index, false));
    }

    disconnectedCallback() {
      clearInterval(this._timer);
      clearTimeout(this._resumeTimer);
    }

    _setupTrack() {
      this.track.style.willChange = 'transform';
      this._jumpTo(this.index, false);
    }

    get slideWidth() {
      return this.getBoundingClientRect().width;
    }

    _jumpTo(index, animate = true) {
      this.track.style.transition = animate ? 'transform 400ms ease' : 'none';
      this.track.style.transform = `translate3d(${-index * this.slideWidth}px, 0, 0)`;
    }

    _next() {
      if (this.dragging) return;
      this.index++;
      this._jumpTo(this.index, true);

      // if we've landed on the cloned last slide, snap back invisibly
      if (this.index === this.track.children.length - 1) {
        this.track.addEventListener(
          'transitionend',
          () => {
            this.index = 1;
            this._jumpTo(this.index, false);
          },
          { once: true },
        );
      }
    }

    _resetAutoplay() {
      clearInterval(this._timer);
      if (!this.paused) {
        this._timer = setInterval(() => this._next(), this.interval);
      }
    }

    _pauseThenResume() {
      this.paused = true;
      clearInterval(this._timer);
      clearTimeout(this._resumeTimer);
      this._resumeTimer = setTimeout(() => {
        this.paused = false;
        this._resetAutoplay();
      }, this.interval);
    }

    _bindEvents() {
      this.addEventListener('mouseenter', () => {
        this.paused = true;
        clearInterval(this._timer);
      });
      this.addEventListener('mouseleave', () => {
        this.paused = false;
        this._resetAutoplay();
      });

      this.addEventListener('pointerdown', (e) => {
        e.preventDefault();
        this.dragging = true;
        this.paused = true;
        clearInterval(this._timer);
        this.startX = e.clientX;
        this.track.style.transition = 'none';
        this.style.cursor = 'grabbing';
        this.setPointerCapture(e.pointerId);
      });

      this.addEventListener('pointermove', (e) => {
        if (!this.dragging) return;
        this.dragOffset = e.clientX - this.startX;
        const base = -this.index * this.slideWidth;
        this.track.style.transform = `translate3d(${base + this.dragOffset}px, 0, 0)`;
      });

      const endDrag = () => {
        if (!this.dragging) return;
        this.dragging = false;
        this.style.cursor = 'grab';

        const threshold = this.slideWidth * 0.2;
        if (this.dragOffset < -threshold) {
          this.index++;
        } else if (this.dragOffset > threshold) {
          this.index--;
        }
        this.dragOffset = 0;
        this._jumpTo(this.index, true);

        // handle wrap-around after manual swipe
        const lastIdx = this.track.children.length - 1;
        if (this.index === lastIdx) {
          this.track.addEventListener(
            'transitionend',
            () => {
              this.index = 1;
              this._jumpTo(this.index, false);
            },
            { once: true },
          );
        } else if (this.index === 0) {
          this.track.addEventListener(
            'transitionend',
            () => {
              this.index = this.realCount;
              this._jumpTo(this.index, false);
            },
            { once: true },
          );
        }

        this._pauseThenResume();
      };

      this.addEventListener('pointerup', endDrag);
      this.addEventListener('pointercancel', endDrag);
      this.addEventListener('pointerleave', endDrag);
    }
  }

  customElements.define('carousel-strip', CarouselStrip);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-immersive-video"]) return;
  try {
    
// Section-Builder: 01-main.js
// ---------------------------------------------------------------------------
  // Carousel Strip
  // ---------------------------------------------------------------------------

  class CarouselStrip extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-track]');
      this.interval = parseInt(this.dataset.interval || '3000', 10);

      // real slide count (before cloning)
      this.realCount = this.track.children.length;

      // clone first and last slide for seamless infinite wrap
      const first = this.track.children[0].cloneNode(true);
      const last = this.track.children[this.realCount - 1].cloneNode(true);
      this.track.appendChild(first);
      this.track.insertBefore(last, this.track.children[0]);

      // index 1 = first real slide (index 0 is the cloned "last")
      this.index = 1;
      this.paused = false;
      this.dragging = false;
      this.startX = 0;
      this.dragOffset = 0;

      this._setupTrack();
      this._bindEvents();
      this._resetAutoplay();

      window.addEventListener('resize', () => this._jumpTo(this.index, false));
    }

    disconnectedCallback() {
      clearInterval(this._timer);
      clearTimeout(this._resumeTimer);
    }

    _setupTrack() {
      this.track.style.willChange = 'transform';
      this._jumpTo(this.index, false);
    }

    get slideWidth() {
      return this.getBoundingClientRect().width;
    }

    _jumpTo(index, animate = true) {
      this.track.style.transition = animate ? 'transform 400ms ease' : 'none';
      this.track.style.transform = `translate3d(${-index * this.slideWidth}px, 0, 0)`;
    }

    _next() {
      if (this.dragging) return;
      this.index++;
      this._jumpTo(this.index, true);

      // if we've landed on the cloned last slide, snap back invisibly
      if (this.index === this.track.children.length - 1) {
        this.track.addEventListener(
          'transitionend',
          () => {
            this.index = 1;
            this._jumpTo(this.index, false);
          },
          { once: true },
        );
      }
    }

    _resetAutoplay() {
      clearInterval(this._timer);
      if (!this.paused) {
        this._timer = setInterval(() => this._next(), this.interval);
      }
    }

    _pauseThenResume() {
      this.paused = true;
      clearInterval(this._timer);
      clearTimeout(this._resumeTimer);
      this._resumeTimer = setTimeout(() => {
        this.paused = false;
        this._resetAutoplay();
      }, this.interval);
    }

    _bindEvents() {
      this.addEventListener('mouseenter', () => {
        this.paused = true;
        clearInterval(this._timer);
      });
      this.addEventListener('mouseleave', () => {
        this.paused = false;
        this._resetAutoplay();
      });

      this.addEventListener('pointerdown', (e) => {
        e.preventDefault();
        this.dragging = true;
        this.paused = true;
        clearInterval(this._timer);
        this.startX = e.clientX;
        this.track.style.transition = 'none';
        this.style.cursor = 'grabbing';
        this.setPointerCapture(e.pointerId);
      });

      this.addEventListener('pointermove', (e) => {
        if (!this.dragging) return;
        this.dragOffset = e.clientX - this.startX;
        const base = -this.index * this.slideWidth;
        this.track.style.transform = `translate3d(${base + this.dragOffset}px, 0, 0)`;
      });

      const endDrag = () => {
        if (!this.dragging) return;
        this.dragging = false;
        this.style.cursor = 'grab';

        const threshold = this.slideWidth * 0.2;
        if (this.dragOffset < -threshold) {
          this.index++;
        } else if (this.dragOffset > threshold) {
          this.index--;
        }
        this.dragOffset = 0;
        this._jumpTo(this.index, true);

        // handle wrap-around after manual swipe
        const lastIdx = this.track.children.length - 1;
        if (this.index === lastIdx) {
          this.track.addEventListener(
            'transitionend',
            () => {
              this.index = 1;
              this._jumpTo(this.index, false);
            },
            { once: true },
          );
        } else if (this.index === 0) {
          this.track.addEventListener(
            'transitionend',
            () => {
              this.index = this.realCount;
              this._jumpTo(this.index, false);
            },
            { once: true },
          );
        }

        this._pauseThenResume();
      };

      this.addEventListener('pointerup', endDrag);
      this.addEventListener('pointercancel', endDrag);
      this.addEventListener('pointerleave', endDrag);
    }
  }

  customElements.define('carousel-strip', CarouselStrip);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["homepage-hero"]) return;
  try {
    
// Section-Builder: optimisied-video.js
class OptimisedVideo extends HTMLElement {
  static _VIDEOPLAYING = "video-playing";
  #observer = /** @type {IntersectionObserver | null} */ (null);
  #isMobile = false;
  #posterMobile;
  #poster;
  #video;
  #videoSource;

  constructor() {
    super();
    this.#isMobile = !window.matchMedia("(min-width: 768px)").matches;
    this.#posterMobile = /** @type {HTMLImageElement} */ (
      this.throw.element("img.md\\:hidden")
    );
    this.#poster = /** @type {HTMLImageElement} */ (
      this.throw.element("img.not-md\\:hidden")
    );
    this.#video = /** @type {HTMLVideoElement} */ (this.throw.element("video"));
    this.#videoSource = /** @type {HTMLSourceElement} */ (
      this.throw.element("source")
    );
  }

  connectedCallback() {
    this.#observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            this.handlePosterLoad();
            this.#observer?.unobserve(this);
          }
        });
      },
      {
        rootMargin: "50px",
        threshold: 0.1,
      },
    );

    this.#observer.observe(this);
  }

  disconnectedCallback() {
    if (this.#observer) {
      this.#observer.disconnect();
    }
  }

  /**
   * Wait for the poster and page to load before loading the video.
   */
  handlePosterLoad() {
    const img = this.#isMobile ? this.#posterMobile : this.#poster;

    const imageReady = img.complete
      ? Promise.resolve()
      : new Promise((resolve) =>
          img.addEventListener("load", resolve, { once: true }),
        );

    const pageReady =
      document.readyState === "complete"
        ? Promise.resolve()
        : new Promise((resolve) =>
            window.addEventListener("load", resolve, { once: true }),
          );

    img.addEventListener(
      "error",
      () => console.warn("Poster failed to load:", img.src),
      { once: true },
    );

    Promise.all([imageReady, pageReady]).then(() => this.loadVideo());
  }

  /**
   * Loads the video source, plays the video, and toggles visibility classes
   */
  loadVideo() {
    const img = this.#isMobile ? this.#posterMobile : this.#poster;

    const src = this.#isMobile
      ? this.#videoSource.getAttribute("data-src-mobile")
      : this.#videoSource.getAttribute("data-src");
    if (!src) throw Error("Video source not found");

    const type = this.#isMobile
      ? this.#videoSource.getAttribute("data-video-type-mobile")
      : this.#videoSource.getAttribute("data-video-type");
    if (!type) throw Error("Video type not found");

    this.#videoSource.src = src;
    this.#videoSource.type = type;
    this.#video.preload = "auto";
    this.#video.load();

    this.#video.addEventListener(
      "canplaythrough",
      () => {
        img.classList.add("opacity-0");
        this.#video.classList.remove("hidden");
        this.#video.play();
        this.#video.dispatchEvent(
          new Event(OptimisedVideo._VIDEOPLAYING, { bubbles: true }),
        );
      },
      { once: true },
    );
  }
}

customElements.define("optimised-video", OptimisedVideo);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-photo-cake"]) return;
  try {
    
// Section-Builder: 01-main.js
/**
   * Custom element that applies perspective (corner-based) warps and optional
   * rotation to all <img data-corners="..."> elements on the page.
   *
   * Usage:
   *   <image-matrix-calculator></image-matrix-calculator>
   * The element itself is invisible; it only performs the initialisation work.
   */
  class ImageMatrixCalculator extends HTMLElement {
    /** @type {ResizeObserver | null} */
    #resizeObserver = null;

    /**
     * Called when the element is inserted into the DOM.
     * Locates all target images and sets up resize observation.
     */
    connectedCallback() {
      const images = document.querySelectorAll('img[data-corners]');
      if (!images.length) return;

      // Apply warp immediately
      images.forEach((img) => this.applyWarp(/** @type {HTMLImageElement} */ (img)));

      // Fires on initial layout, viewport resize, breakpoint changes,
      // and when a previously hidden (display:none) element becomes visible.
      const observer = new ResizeObserver((entries) => {
        for (const entry of entries) {
          this.applyWarp(/** @type {HTMLImageElement} */ (entry.target));
        }
      });
      images.forEach((img) => observer.observe(img));
      this.#resizeObserver = observer; // keep a reference for cleanup
    }

    /**
     * Clean up observers / listeners when the element is removed.
     */
    disconnectedCallback() {
      if (this.#resizeObserver) {
        this.#resizeObserver.disconnect();
        this.#resizeObserver = null;
      }
    }

    /**
     * @typedef {Object} Point
     * @property {number} x
     * @property {number} y
     */

    /**
     * @typedef {Object} Corners
     * @property {Point} tl Top-left corner offset
     * @property {Point} tr Top-right corner offset
     * @property {Point} bl Bottom-left corner offset
     * @property {Point} br Bottom-right corner offset
     */

    /**
     * Converts four corner offsets into a CSS matrix3d() transform that maps
     * the unit square [0,w]×[0,h] onto the given quadrilateral.
     *
     * @param {number} w Image width in pixels
     * @param {number} h Image height in pixels
     * @param {Corners} corners Absolute pixel offsets for each corner (relative to the un-transformed image).
     * @returns {string} A complete CSS `matrix3d(...)` value.
     */
    cornersToMatrix3d(w, h, corners) {
      const p0 = { x: corners.tl.x, y: corners.tl.y };
      const p1 = { x: w + corners.tr.x, y: corners.tr.y };
      const p2 = { x: w + corners.br.x, y: h + corners.br.y };
      const p3 = { x: corners.bl.x, y: h + corners.bl.y };

      const { x: x0, y: y0 } = p0;
      const { x: x1, y: y1 } = p1;
      const { x: x2, y: y2 } = p2;
      const { x: x3, y: y3 } = p3;

      const dx1 = x1 - x2;
      const dx2 = x3 - x2;
      const dx3 = x0 - x1 + x2 - x3;
      const dy1 = y1 - y2;
      const dy2 = y3 - y2;
      const dy3 = y0 - y1 + y2 - y3;

      let a, b, c, d, e, f, g, hh, i;

      // Affine case (no perspective)
      if (Math.abs(dx3) < 1e-9 && Math.abs(dy3) < 1e-9) {
        a = x1 - x0;
        b = x2 - x1;
        c = x0;
        d = y1 - y0;
        e = y2 - y1;
        f = y0;
        g = 0;
        hh = 0;
        i = 1;
      } else {
        // Full projective case
        const denom = dx1 * dy2 - dx2 * dy1;
        g = (dx3 * dy2 - dx2 * dy3) / denom;
        hh = (dx1 * dy3 - dx3 * dy1) / denom;
        a = x1 - x0 + g * x1;
        b = x3 - x0 + hh * x3;
        c = x0;
        d = y1 - y0 + g * y1;
        e = y3 - y0 + hh * y3;
        f = y0;
        i = 1;
      }

      // Normalise by image dimensions so the transform is independent of size
      const a2 = a / w;
      const b2 = b / h;
      const c2 = c;
      const d2 = d / w;
      const e2 = e / h;
      const f2 = f;
      const g2 = g / w;
      const h2 = hh / h;
      const i2 = i;

      return `matrix3d(${a2},${d2},0,${g2}, ${b2},${e2},0,${h2}, 0,0,1,0, ${c2},${f2},0,${i2})`;
    }

    /**
     * Reads data-corners / data-rotation from an image and applies the
     * corresponding CSS transform.
     *
     * @param {HTMLImageElement} img
     */
    applyWarp(img) {
      const w = img.offsetWidth;
      const h = img.offsetHeight;
      if (!w || !h) return; // still hidden or not laid out

      /** @type {Record<string, {x?: number, y?: number}>} */
      let pct;
      try {
        pct = JSON.parse(img.dataset.corners ?? '{}');
      } catch {
        return; // malformed JSON – silently ignore
      }

      const corners = {
        tl: { x: 0, y: 0 },
        tr: { x: 0, y: 0 },
        bl: { x: 0, y: 0 },
        br: { x: 0, y: 0 },
      };

      for (const key of /** @type {const} */ (['tl', 'tr', 'bl', 'br'])) {
        const c = pct[key] ?? { x: 0, y: 0 };
        corners[key] = {
          x: ((c.x ?? 0) / 100) * w,
          y: ((c.y ?? 0) / 100) * h,
        };
      }

      img.style.transformOrigin = '0 0';
      img.style.transform = this.cornersToMatrix3d(w, h, corners);
    }
  }

  customElements.define('image-matrix-calculator', ImageMatrixCalculator);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-judgeme"]) return;
  try {
    
// Section-Builder: judgeme.js
class JudgeMeReviews extends HTMLElement {
  #page = 1;
  #totalPages = 0;
  #loading = false;
  #ready = false;

  /** @type {Map<number, ParsedReview[]>} Reviews already fetched, by page. */
  #cache = new Map();

  /** @type {AbortController|null} Controller for the in-flight request. */
  #abort = null;

  #bodyEl;
  #cardsEl;
  #errorEl;
  #emptyEl;
  #cardTemplate;
  #prevBtn;
  #nextBtn;
  #indicatorEl;

  #shopDomain;
  #productID;
  #perPage;

  constructor() {
    super();
    const shopDomain = this.getAttribute("shop-domain");
    if (!shopDomain) {
      throw Error(`[JudgeMe]: missing attribute 'shop-domain'`);
    }
    this.#shopDomain = shopDomain;
    const productID = this.getAttribute("product-id");
    if (!productID) {
      throw Error(`[JudgeMe]: missing attribute 'product-id'`);
    }
    this.#productID = productID;
    this.#perPage = parseInt(this.getAttribute("per-page") || "5", 10);
    this.#bodyEl = this.throw.element('[data-name="body"]');
    this.#cardsEl = this.throw.element('[data-name="cards"]');
    this.#cardTemplate = this.throw.element('[data-name="card-template"]');
    this.#errorEl = this.throw.element('[data-name="status-error"]');
    this.#emptyEl = this.throw.element('[data-name="status-empty"]');
    this.#prevBtn = /** @type {HTMLButtonElement} */ (
      this.throw.element('[data-name="page-prev"]')
    );
    this.#nextBtn = /** @type {HTMLButtonElement} */ (
      this.throw.element('[data-name="page-next"]')
    );
    // Optional: e.g. <span data-name="page-indicator"></span> -> "Page 2 of 5"
    this.#indicatorEl = this.querySelector('[data-name="page-indicator"]');

    this.#prevBtn.addEventListener("click", () => this.prevPage());
    this.#nextBtn.addEventListener("click", () => this.nextPage());
  }

  connectedCallback() {
    if (this.#ready) return;
    this.#ready = true;

    this.#load(1);
  }

  disconnectedCallback() {
    this.#abort?.abort();
  }

  /** @returns {number} Current page (1-based). */
  get page() {
    return this.#page;
  }

  /** @returns {number} Total number of pages, or 0 if unknown. */
  get totalPages() {
    return this.#totalPages;
  }

  /**
   * Goes to the given page. Out-of-range pages are ignored.
   *
   * @param {number} page - 1-based page number.
   * @returns {Promise<void>}
   */
  goToPage(page) {
    const max = this.#totalPages || 1;
    if (!Number.isInteger(page) || page < 1 || page > max) {
      return Promise.resolve();
    }
    return this.#load(page);
  }

  nextPage() {
    return this.goToPage(this.#page + 1);
  }

  prevPage() {
    return this.goToPage(this.#page - 1);
  }

  /**
   * @param {number} page - Page number to fetch.
   * @returns {string} Fully-qualified API URL.
   */
  #apiUrl(page) {
    const shop = encodeURIComponent(this.#shopDomain);
    const pid = encodeURIComponent(this.#productID);
    return `https://api.judge.me/reviews/reviews_for_widget?url=${shop}&shop_domain=${shop}&platform=shopify&page=${page}&per_page=${this.#perPage}&product_id=${pid}`;
  }

  /**
   * Shows a page, fetching it first if it isn't cached. A newer call cancels
   * any request still in flight.
   *
   * @param {number} page - Page number to show.
   * @returns {Promise<void>}
   */
  async #load(page) {
    this.#abort?.abort();
    const abort = (this.#abort = new AbortController());
    this.#setLoading(true);

    try {
      let reviews = this.#cache.get(page);
      if (!reviews) {
        const res = await fetch(this.#apiUrl(page), { signal: abort.signal });
        if (!res.ok) throw new Error(`HTTP ${res.status}`);
        const data = await res.json();
        reviews = this.#parseHtml(data.html || "");
        this.#cache.set(page, reviews);
        this.#totalPages = Math.ceil((data.total_count ?? 0) / this.#perPage);
      }
      this.#page = page;
      this.#renderReviews(reviews);
    } catch (err) {
      if (err instanceof Error && err.name !== "AbortError") {
        this.#showError(err.message);
      }
    } finally {
      // Only the latest request controls the loading state.
      if (this.#abort === abort) this.#setLoading(false);
    }
  }

  /**
   * @param {boolean} isLoading
   */
  #setLoading(isLoading) {
    this.#loading = isLoading;
    this.#bodyEl.toggleAttribute("data-loading", isLoading);
    this.#updateControls();
  }

  #updateControls() {
    this.#prevBtn.disabled = this.#loading || this.#page <= 1;
    this.#nextBtn.disabled = this.#loading || this.#page >= this.#totalPages;
    if (this.#indicatorEl) {
      this.#indicatorEl.textContent = this.#totalPages
        ? `Page ${this.#page} of ${this.#totalPages}`
        : "";
    }
  }

  /**
   * @param {string} msg
   */
  #showError(msg) {
    this.#errorEl.textContent = `ERROR - Unable to load reviews: ${msg}`;
    this.#errorEl.classList.remove("hidden");
  }

  /**
   * @typedef {Object} ParsedReview
   * @property {number} score - Rating score (0-5).
   * @property {string} author - Reviewer display name.
   * @property {string} timestamp - Raw timestamp string from Judge.me.
   * @property {string} title - Review title.
   * @property {string} body - Review body text.
   * @property {boolean} verified - Whether the reviewer is a verified buyer.
   * @property {string[]} pics - Review image URLs.
   */

  /**
   * Parses the HTML fragment returned by the Judge.me API.
   *
   * @param {string} htmlString - The `html` field from the API response.
   * @returns {ParsedReview[]}
   */
  #parseHtml(htmlString) {
    const doc = new DOMParser().parseFromString(htmlString, "text/html");
    /**
     * @param {ParentNode} node
     * @param {string} selector
     * @returns {string}
     */
    const text = (node, selector) =>
      node.querySelector(selector)?.textContent.trim() || "";

    return Array.from(doc.querySelectorAll(".jdgm-rev"), (node) => ({
      score: parseInt(
        node.querySelector(".jdgm-rev__rating")?.getAttribute("data-score") ||
          "0",
        10,
      ),
      author: text(node, ".jdgm-rev__author") || "Anonymous",
      timestamp:
        node
          .querySelector(".jdgm-rev__timestamp")
          ?.getAttribute("data-content") || "",
      title: text(node, ".jdgm-rev__title"),
      body: text(node, ".jdgm-rev__body"),
      verified: node.getAttribute("data-verified-buyer") === "true",
      pics: Array.from(node.querySelectorAll(".jdgm-rev__pics img"))
        .map((img) => img.getAttribute("src"))
        .filter((src) => src !== null),
    }));
  }

  /**
   * @param {string} iso - Raw timestamp (e.g. `2024-01-15 10:30:00 UTC`).
   * @returns {string} Localized date, or the original string if unparseable.
   */
  #formatDate(iso) {
    if (!iso) return "";
    const d = new Date(iso.replace(" ", "T").replace(" UTC", "Z"));
    if (Number.isNaN(d.getTime())) return iso;
    return d.toLocaleDateString(undefined, {
      year: "numeric",
      month: "short",
      day: "numeric",
    });
  }

  /**
   * @param {Element} container - Element to render stars into.
   * @param {number} score - Rating score (0-5).
   */
  #renderStars(container, score) {
    container.replaceChildren(
      ...Array.from({ length: 5 }, (_, i) => {
        const star = document.createElement("span");
        star.className = `${i < score ? "text-amber-400" : "text-gray-200"} text-sm`;
        star.textContent = "★";
        return star;
      }),
    );
  }

  /**
   * Replaces the cards with the given reviews.
   *
   * @param {ParsedReview[]} reviews
   */
  #renderReviews(reviews) {
    this.#errorEl.classList.add("hidden");
    this.#emptyEl.classList.toggle("hidden", reviews.length > 0);

    for (const child of Array.from(this.#cardsEl.children)) {
      if (child !== this.#cardTemplate) child.remove();
    }
    this.#cardsEl.scrollTo({ left: 0 });

    this.#cardsEl.append(...reviews.map((r) => this.#buildCard(r)));
  }

  /**
   * @param {ParsedReview} r
   * @returns {HTMLElement}
   */
  #buildCard(r) {
    const card = /** @type {HTMLElement} */ (
      this.#cardTemplate.cloneNode(true)
    );
    card.removeAttribute("data-name");
    card.removeAttribute("hidden");

    /** @param {string} name     */
    const el = (name) => card.throw.element(`[data-name="${name}"]`);

    // Sets text on an element, or removes the element if there's no text.
    /**
     * @param {string} name
     * @param {string} value
     */
    const setText = (name, value) => {
      const node = el(name);
      if (value) node.textContent = value;
      else node.remove();
    };

    setText("avatar", (r.author[0] || "?").toUpperCase());
    setText("author", r.author);
    setText("title", r.title);
    setText("review-body", r.body);
    setText("date", this.#formatDate(r.timestamp));

    if (!r.verified) el("verified")?.remove();

    const stars = el("stars");
    if (stars) this.#renderStars(stars, r.score);

    const pics = el("pics");
    if (pics) {
      if (r.pics.length) {
        pics.replaceChildren(
          ...r.pics.map((src) => {
            const img = document.createElement("img");
            img.src = src;
            img.loading = "lazy";
            img.className = "w-14 h-14 object-cover rounded-md";
            return img;
          }),
        );
      } else {
        pics.remove();
      }
    }

    return card;
  }
}

customElements.define("judgeme-reviews", JudgeMeReviews);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-logo"]) return;
  try {
    
// Section-Builder: elastic-scroll.js
class ElasticScroll extends HTMLElement {
  // ---------------------------------------------------------------------------
  // Signals and State Variables
  // ---------------------------------------------------------------------------
  #position = signal(0);
  #maxPosition = signal(0);
  #isDragging = signal(false);
  #itemWidth = signal(0);
  #containerWidth = signal(0);
  #lastActiveIndex = 0;
  #velocity = signal(0);

  // Computed signals (initialized in constructor)
  #isAtStart;
  #isAtEnd;

  // Drag tracking variables
  #startX = 0;
  #startY = 0;
  #startPosition = 0;
  #lastX = 0;
  #lastTime = 0;
  #lastTickTime = 0;
  #currentDt = 16.67;
  #isMoving = false;

  // Animation & Configuration Constants
  #FRICTION = 0.93;
  #SNAP_BACK_SPEED = 0.15;
  #DRAG_SENSITIVITY = 1.33;
  #animationFrameId = 0;

  // Temporary State for Batch Callbacks (to avoid closures)
  #currentEventPageX = 0;
  #currentEventPageY = 0;
  #currentEventTime = 0;
  #currentTargetPos = 0;
  #currentVelocityPeek = 0;
  #currentPosPeek = 0;
  #currentMaxPosPeek = 0;
  #isOverscrolled = false;
  #shouldRequestFrame = false;

  /** @type {NodeJS.Timeout | null}  */
  resizeTimer = null;
  #bullets = /** @type {HTMLButtonElement[]} */ ([]);

  constructor() {
    super();

    // DOM Elements
    this.prevBtn = /** @type {HTMLButtonElement} */ (
      this.throw.element("button[data-previous]")
    );
    this.nextBtn = /** @type {HTMLButtonElement} */ (
      this.throw.element("button[data-next]")
    );
    this.pagination = this.throw.element("[data-pagination]");
    this.track = this.throw.element("[data-track]");
    this.items = [...this.throw.any("[data-item]")];

    if (this.items.length === 0) {
      throw Error("[elastic-scroll]: No items found");
    }

    // Initialize Computed Signals
    this.#isAtStart = computed(this.#isAtStartCalc);
    this.#isAtEnd = computed(this.#isAtEndCalc);
  }

  connectedCallback() {
    this.measureAndCacheDOM();
    this.prevBtn.addEventListener("click", () => this.scrollByBullets(-1));
    this.nextBtn.addEventListener("click", () => this.scrollByBullets(1));
    window.addEventListener("resize", this.handleResize);
    this.updateNumberOfBullets();
    this.addDragListeners();
    this.setupEffects();
    this.updateActiveBullet();
  }

  disconnectedCallback() {
    window.removeEventListener("resize", this.handleResize);
    this.removeDragListeners();
    this.#cancelMomentum();
    if (this.resizeTimer !== null) clearTimeout(this.resizeTimer);
  }

  // ---------------------------------------------------------------------------
  // Pre-bound Callbacks via Private Class Fields
  // ---------------------------------------------------------------------------

  #isAtStartCalc = () => {
    return this.#position.value >= 0;
  };

  #isAtEndCalc = () => {
    return this.#position.value <= this.#maxPosition.value;
  };

  #syncTransform = () => {
    this.track.style.transform = `translate3d(${this.#position.value}px, 0, 0)`;
  };

  #syncButtons = () => {
    const isStart = this.#isAtStart.value;
    const isEnd = this.#isAtEnd.value;

    if (this.prevBtn.disabled !== isStart) {
      this.prevBtn.disabled = isStart;
    }
    if (this.nextBtn.disabled !== isEnd) {
      this.nextBtn.disabled = isEnd;
    }
  };

  #syncBullets = () => {
    this.#position.value;
    this.#maxPosition.value;
    this.#itemWidth.value;
    this.updateActiveBullet();
  };

  #momentumEffect = () => {
    if (this.#isDragging.value) return;
    this.#animationFrameId = requestAnimationFrame(this.#tick);
    return this.#cancelMomentum;
  };

  #cancelMomentum = () => {
    cancelAnimationFrame(this.#animationFrameId);
  };

  #tick = () => {
    const now = performance.now();
    const dt = this.#lastTickTime ? now - this.#lastTickTime : 16.67;
    this.#lastTickTime = now;
    // Clamp to avoid huge jumps after a dropped/backgrounded tab
    this.#currentDt = Math.min(dt, 32);

    this.#currentVelocityPeek = this.#velocity.peek();
    this.#currentPosPeek = this.#position.peek();
    this.#currentMaxPosPeek = this.#maxPosition.peek();
    this.#isOverscrolled =
      this.#currentPosPeek > 0 ||
      this.#currentPosPeek < this.#currentMaxPosPeek;

    batch(this.#tickBatch);

    if (this.#shouldRequestFrame) {
      this.#animationFrameId = requestAnimationFrame(this.#tick);
    } else {
      this.#lastTickTime = 0; // reset so next momentum start doesn't use a stale dt
    }
  };

  #tickBatch = () => {
    let v = this.#currentVelocityPeek;
    const pos = this.#currentPosPeek;
    const maxPos = this.#currentMaxPosPeek;
    const dt = this.#currentDt;
    this.#shouldRequestFrame = true;

    if (this.#isOverscrolled) {
      this.#velocity.value = 0;
      if (pos > 0) {
        this.#position.value = pos * (1 - this.#SNAP_BACK_SPEED);
        if (this.#position.value < 0.1) this.#position.value = 0;
      } else {
        this.#position.value =
          maxPos + (pos - maxPos) * (1 - this.#SNAP_BACK_SPEED);
        if (this.#position.value > maxPos - 0.1) {
          this.#position.value = maxPos;
        }
      }
    } else if (Math.abs(v) > 0.01) {
      let nextPos = pos + v * dt;
      if (nextPos > 0) {
        v *= 0.1;
        nextPos = pos + v * dt;
      } else if (nextPos < maxPos) {
        v *= 0.1;
        nextPos = pos + v * dt;
      }
      // friction should also be dt-aware so it feels the same at any refresh rate
      const frictionThisFrame = Math.pow(this.#FRICTION, dt / 16.67);
      this.#velocity.value = v * frictionThisFrame;
      this.#position.value = nextPos;
    } else {
      this.#velocity.value = 0;
      this.#shouldRequestFrame = false;
    }
  };

  #isBulletSelected = (element) => {
    return element.hasAttribute("data-selected");
  };

  #clearTransition = () => {
    this.track.style.transition = "";
  };

  #onBulletClick = (e) => {
    const target = Number(e.currentTarget.dataset.target);
    this.animateTo(target);
  };

  #startDragBatch = () => {
    this.#isDragging.value = true;
    this.#startX = this.#currentEventPageX;
    this.#startY = this.#currentEventPageY;
    this.#startPosition = this.#position.peek();
  };

  #startDrag = (e) => {
    this.#currentEventPageX = this.#getPageX(e);
    this.#currentEventPageY = this.#getPageY(e);
    batch(this.#startDragBatch);

    this.#lastX = this.#currentEventPageX;
    this.#lastTime = performance.now();
    this.track.style.transition = "";
    this.#isMoving = false;
  };

  #moveDragBatch = () => {
    this.#velocity.value = 0;
    const deltaTime = this.#currentEventTime - this.#lastTime;

    if (deltaTime > 1) {
      const rawVelocity =
        ((this.#currentEventPageX - this.#lastX) * this.#DRAG_SENSITIVITY) /
        deltaTime;
      this.#velocity.value = this.#velocity.peek() * 0.4 + rawVelocity * 0.6;
    }

    const maxPos = this.#maxPosition.peek();

    if (this.#currentTargetPos > 0) {
      this.#position.value = this.#currentTargetPos * 0.3;
    } else if (this.#currentTargetPos < maxPos) {
      this.#position.value = maxPos + (this.#currentTargetPos - maxPos) * 0.3;
    } else {
      this.#position.value = this.#currentTargetPos;
    }

    this.#lastX = this.#currentEventPageX;
    this.#lastTime = this.#currentEventTime;
  };

  #moveDrag = (e) => {
    if (!this.#isDragging.peek()) return;

    this.#currentEventPageX = this.#getPageX(e);
    this.#currentEventTime = performance.now();

    const deltaX = this.#currentEventPageX - this.#startX;
    const walk = deltaX * this.#DRAG_SENSITIVITY;

    this.#currentTargetPos = this.#startPosition + walk;
    this.#isMoving = true;

    batch(this.#moveDragBatch);
  };

  #endDragFrame = () => {
    this.#isMoving = false;
    this.#isDragging.value = false;
  };

  #endDrag = () => {
    if (performance.now() - this.#lastTime > 50) {
      this.#velocity.value = 0;
    }
    requestAnimationFrame(this.#endDragFrame);
  };

  #onMouseMove = (e) => {
    if (this.#isDragging.peek()) e.preventDefault();
    this.#moveDrag(e);
  };

  #onTouchMove = (e) => {
    const dx = Math.abs(this.#getPageX(e) - this.#startX);
    const dy = Math.abs(this.#getPageY(e) - this.#startY);
    if (dx > dy && e.cancelable) e.preventDefault();
    this.#moveDrag(e);
  };

  #onClick = (e) => {
    const link = e.target.closest("a");
    if (this.#isMoving) {
      e.preventDefault();
      e.stopImmediatePropagation();
      return false;
    }
  };

  #measureAndCacheDOMBatch = () => {
    this.#containerWidth.value = Math.min(
      this.track.clientWidth,
      this.clientWidth,
    );
    const trackStyle = getComputedStyle(this.track);
    const gap = parseFloat(trackStyle.gap) || 0;

    this.#itemWidth.value = this.items[0].offsetWidth + gap;
    const paddingLeft = parseFloat(trackStyle.paddingLeft) || 0;

    this.#maxPosition.value = -(
      this.track.scrollWidth +
      paddingLeft -
      this.#containerWidth.peek()
    );
  };

  #handleResizeTimeout = () => {
    this.measureAndCacheDOM();
    this.#position.value = Math.max(
      this.#maxPosition.peek(),
      Math.min(0, this.#position.peek()),
    );
    this.updateNumberOfBullets();
  };

  // We make handleResize a public arrow function to avoid needing to bind it in the constructor
  handleResize = () => {
    if (this.resizeTimer !== null) clearTimeout(this.resizeTimer);
    this.resizeTimer = setTimeout(this.#handleResizeTimeout, 150);
  };

  // ---------------------------------------------------------------------------
  // Setup & Layout Methods
  // ---------------------------------------------------------------------------

  setupEffects() {
    effect(this.#syncTransform);
    effect(this.#syncButtons);
    effect(this.#syncBullets);
    effect(this.#momentumEffect);
  }

  scrollByBullets(direction) {
    const i = this.#bullets.findIndex(this.#isBulletSelected);
    if (this.#bullets[i + direction]) {
      this.#bullets[i + direction].click();
    }
  }

  snapToNearest() {
    const itemW = this.#itemWidth.peek();
    const index = Math.round(-this.#position.peek() / itemW);
    const clamped = Math.max(0, Math.min(this.items.length - 1, index));
    this.animateTo(Math.max(this.#maxPosition.peek(), -(clamped * itemW)));
  }

  animateTo(target) {
    this.track.style.transition =
      "transform 0.4s cubic-bezier(0.25, 1, 0.5, 1)";
    this.#position.value = target;
    setTimeout(this.#clearTransition, 400);
  }

  updateActiveBullet() {
    if (this.#bullets.length < 2) return;

    let activePageIndex = 0;
    const totalBullets = this.#bullets.length;
    const currentPos = this.#position.peek();
    const maxPos = this.#maxPosition.peek();
    const itemW = this.#itemWidth.peek();

    if (currentPos <= maxPos) {
      activePageIndex = totalBullets - 1;
    } else if (currentPos >= 0) {
      activePageIndex = 0;
    } else if (totalBullets === 2) {
      activePageIndex = currentPos === maxPos ? 1 : 0;
    } else {
      const itemsPerPage = Math.max(
        1,
        Math.floor(this.#containerWidth.peek() / itemW),
      );
      activePageIndex = Math.max(
        0,
        Math.min(
          totalBullets - 1,
          Math.round(-currentPos / (itemW * itemsPerPage)),
        ),
      );
    }

    if (activePageIndex === this.#lastActiveIndex) return;
    this.#lastActiveIndex = activePageIndex;

    for (let i = 0; i < this.#bullets.length; i++) {
      this.#bullets[i].toggleAttribute("data-selected", i === activePageIndex);
    }
  }

  updateNumberOfBullets() {
    const itemW = this.#itemWidth.peek();
    const itemsPerPage = Math.max(
      1,
      Math.floor(this.#containerWidth.peek() / itemW),
    );
    const totalPages = Math.ceil(this.items.length / itemsPerPage);
    const currentButtons = this.pagination.throw.any("button");

    for (let i = 1; i < currentButtons.length; i++) {
      currentButtons[i].remove();
    }

    const template = currentButtons[0];
    this.#bullets = [];

    for (let i = 0; i < totalPages; i++) {
      const bullet = /** @type {HTMLButtonElement} */ (
        template.cloneNode(true)
      );
      const targetPos = Math.max(
        this.#maxPosition.peek(),
        -(i * itemsPerPage * this.#itemWidth.peek()),
      );
      bullet.dataset.target = targetPos.toString();
      bullet.addEventListener("click", this.#onBulletClick);

      this.pagination.appendChild(bullet);
      this.#bullets.push(bullet);
    }

    template.remove();
    if (totalPages < 2) {
      this.pagination.setAttribute("data-hidden", "");
    } else {
      this.pagination.removeAttribute("data-hidden");
    }

    this.#lastActiveIndex = -1;
    this.updateActiveBullet();
  }

  #getPageX(e) {
    return e.touches?.[0]?.pageX ?? e.pageX;
  }

  #getPageY(e) {
    return e.touches?.[0]?.pageY ?? e.pageY;
  }

  addDragListeners() {
    this.addEventListener("mousedown", this.#startDrag);
    this.addEventListener("mousemove", this.#onMouseMove);
    window.addEventListener("mouseup", this.#endDrag);
    this.addEventListener("mouseleave", this.#endDrag);

    this.addEventListener("touchstart", this.#startDrag, { passive: false });
    this.addEventListener("touchmove", this.#onTouchMove, { passive: false });
    window.addEventListener("touchend", this.#endDrag);
    window.addEventListener("touchcancel", this.#endDrag);
    this.addEventListener("click", this.#onClick, true);
  }

  measureAndCacheDOM() {
    batch(this.#measureAndCacheDOMBatch);
  }

  removeDragListeners() {
    window.removeEventListener("mouseup", this.#endDrag);
    window.removeEventListener("touchend", this.#endDrag);
    window.removeEventListener("touchcancel", this.#endDrag);
  }
}

customElements.define("elastic-scroll", ElasticScroll);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-main"]) return;
  try {
    
// Section-Builder: elastic-scroll.js
class ElasticScroll extends HTMLElement {
  // ---------------------------------------------------------------------------
  // Signals and State Variables
  // ---------------------------------------------------------------------------
  #position = signal(0);
  #maxPosition = signal(0);
  #isDragging = signal(false);
  #itemWidth = signal(0);
  #containerWidth = signal(0);
  #lastActiveIndex = 0;
  #velocity = signal(0);

  // Computed signals (initialized in constructor)
  #isAtStart;
  #isAtEnd;

  // Drag tracking variables
  #startX = 0;
  #startY = 0;
  #startPosition = 0;
  #lastX = 0;
  #lastTime = 0;
  #lastTickTime = 0;
  #currentDt = 16.67;
  #isMoving = false;

  // Animation & Configuration Constants
  #FRICTION = 0.93;
  #SNAP_BACK_SPEED = 0.15;
  #DRAG_SENSITIVITY = 1.33;
  #animationFrameId = 0;

  // Temporary State for Batch Callbacks (to avoid closures)
  #currentEventPageX = 0;
  #currentEventPageY = 0;
  #currentEventTime = 0;
  #currentTargetPos = 0;
  #currentVelocityPeek = 0;
  #currentPosPeek = 0;
  #currentMaxPosPeek = 0;
  #isOverscrolled = false;
  #shouldRequestFrame = false;

  /** @type {NodeJS.Timeout | null}  */
  resizeTimer = null;
  #bullets = /** @type {HTMLButtonElement[]} */ ([]);

  constructor() {
    super();

    // DOM Elements
    this.prevBtn = /** @type {HTMLButtonElement} */ (
      this.throw.element("button[data-previous]")
    );
    this.nextBtn = /** @type {HTMLButtonElement} */ (
      this.throw.element("button[data-next]")
    );
    this.pagination = this.throw.element("[data-pagination]");
    this.track = this.throw.element("[data-track]");
    this.items = [...this.throw.any("[data-item]")];

    if (this.items.length === 0) {
      throw Error("[elastic-scroll]: No items found");
    }

    // Initialize Computed Signals
    this.#isAtStart = computed(this.#isAtStartCalc);
    this.#isAtEnd = computed(this.#isAtEndCalc);
  }

  connectedCallback() {
    this.measureAndCacheDOM();
    this.prevBtn.addEventListener("click", () => this.scrollByBullets(-1));
    this.nextBtn.addEventListener("click", () => this.scrollByBullets(1));
    window.addEventListener("resize", this.handleResize);
    this.updateNumberOfBullets();
    this.addDragListeners();
    this.setupEffects();
    this.updateActiveBullet();
  }

  disconnectedCallback() {
    window.removeEventListener("resize", this.handleResize);
    this.removeDragListeners();
    this.#cancelMomentum();
    if (this.resizeTimer !== null) clearTimeout(this.resizeTimer);
  }

  // ---------------------------------------------------------------------------
  // Pre-bound Callbacks via Private Class Fields
  // ---------------------------------------------------------------------------

  #isAtStartCalc = () => {
    return this.#position.value >= 0;
  };

  #isAtEndCalc = () => {
    return this.#position.value <= this.#maxPosition.value;
  };

  #syncTransform = () => {
    this.track.style.transform = `translate3d(${this.#position.value}px, 0, 0)`;
  };

  #syncButtons = () => {
    const isStart = this.#isAtStart.value;
    const isEnd = this.#isAtEnd.value;

    if (this.prevBtn.disabled !== isStart) {
      this.prevBtn.disabled = isStart;
    }
    if (this.nextBtn.disabled !== isEnd) {
      this.nextBtn.disabled = isEnd;
    }
  };

  #syncBullets = () => {
    this.#position.value;
    this.#maxPosition.value;
    this.#itemWidth.value;
    this.updateActiveBullet();
  };

  #momentumEffect = () => {
    if (this.#isDragging.value) return;
    this.#animationFrameId = requestAnimationFrame(this.#tick);
    return this.#cancelMomentum;
  };

  #cancelMomentum = () => {
    cancelAnimationFrame(this.#animationFrameId);
  };

  #tick = () => {
    const now = performance.now();
    const dt = this.#lastTickTime ? now - this.#lastTickTime : 16.67;
    this.#lastTickTime = now;
    // Clamp to avoid huge jumps after a dropped/backgrounded tab
    this.#currentDt = Math.min(dt, 32);

    this.#currentVelocityPeek = this.#velocity.peek();
    this.#currentPosPeek = this.#position.peek();
    this.#currentMaxPosPeek = this.#maxPosition.peek();
    this.#isOverscrolled =
      this.#currentPosPeek > 0 ||
      this.#currentPosPeek < this.#currentMaxPosPeek;

    batch(this.#tickBatch);

    if (this.#shouldRequestFrame) {
      this.#animationFrameId = requestAnimationFrame(this.#tick);
    } else {
      this.#lastTickTime = 0; // reset so next momentum start doesn't use a stale dt
    }
  };

  #tickBatch = () => {
    let v = this.#currentVelocityPeek;
    const pos = this.#currentPosPeek;
    const maxPos = this.#currentMaxPosPeek;
    const dt = this.#currentDt;
    this.#shouldRequestFrame = true;

    if (this.#isOverscrolled) {
      this.#velocity.value = 0;
      if (pos > 0) {
        this.#position.value = pos * (1 - this.#SNAP_BACK_SPEED);
        if (this.#position.value < 0.1) this.#position.value = 0;
      } else {
        this.#position.value =
          maxPos + (pos - maxPos) * (1 - this.#SNAP_BACK_SPEED);
        if (this.#position.value > maxPos - 0.1) {
          this.#position.value = maxPos;
        }
      }
    } else if (Math.abs(v) > 0.01) {
      let nextPos = pos + v * dt;
      if (nextPos > 0) {
        v *= 0.1;
        nextPos = pos + v * dt;
      } else if (nextPos < maxPos) {
        v *= 0.1;
        nextPos = pos + v * dt;
      }
      // friction should also be dt-aware so it feels the same at any refresh rate
      const frictionThisFrame = Math.pow(this.#FRICTION, dt / 16.67);
      this.#velocity.value = v * frictionThisFrame;
      this.#position.value = nextPos;
    } else {
      this.#velocity.value = 0;
      this.#shouldRequestFrame = false;
    }
  };

  #isBulletSelected = (element) => {
    return element.hasAttribute("data-selected");
  };

  #clearTransition = () => {
    this.track.style.transition = "";
  };

  #onBulletClick = (e) => {
    const target = Number(e.currentTarget.dataset.target);
    this.animateTo(target);
  };

  #startDragBatch = () => {
    this.#isDragging.value = true;
    this.#startX = this.#currentEventPageX;
    this.#startY = this.#currentEventPageY;
    this.#startPosition = this.#position.peek();
  };

  #startDrag = (e) => {
    this.#currentEventPageX = this.#getPageX(e);
    this.#currentEventPageY = this.#getPageY(e);
    batch(this.#startDragBatch);

    this.#lastX = this.#currentEventPageX;
    this.#lastTime = performance.now();
    this.track.style.transition = "";
    this.#isMoving = false;
  };

  #moveDragBatch = () => {
    this.#velocity.value = 0;
    const deltaTime = this.#currentEventTime - this.#lastTime;

    if (deltaTime > 1) {
      const rawVelocity =
        ((this.#currentEventPageX - this.#lastX) * this.#DRAG_SENSITIVITY) /
        deltaTime;
      this.#velocity.value = this.#velocity.peek() * 0.4 + rawVelocity * 0.6;
    }

    const maxPos = this.#maxPosition.peek();

    if (this.#currentTargetPos > 0) {
      this.#position.value = this.#currentTargetPos * 0.3;
    } else if (this.#currentTargetPos < maxPos) {
      this.#position.value = maxPos + (this.#currentTargetPos - maxPos) * 0.3;
    } else {
      this.#position.value = this.#currentTargetPos;
    }

    this.#lastX = this.#currentEventPageX;
    this.#lastTime = this.#currentEventTime;
  };

  #moveDrag = (e) => {
    if (!this.#isDragging.peek()) return;

    this.#currentEventPageX = this.#getPageX(e);
    this.#currentEventTime = performance.now();

    const deltaX = this.#currentEventPageX - this.#startX;
    const walk = deltaX * this.#DRAG_SENSITIVITY;

    this.#currentTargetPos = this.#startPosition + walk;
    this.#isMoving = true;

    batch(this.#moveDragBatch);
  };

  #endDragFrame = () => {
    this.#isMoving = false;
    this.#isDragging.value = false;
  };

  #endDrag = () => {
    if (performance.now() - this.#lastTime > 50) {
      this.#velocity.value = 0;
    }
    requestAnimationFrame(this.#endDragFrame);
  };

  #onMouseMove = (e) => {
    if (this.#isDragging.peek()) e.preventDefault();
    this.#moveDrag(e);
  };

  #onTouchMove = (e) => {
    const dx = Math.abs(this.#getPageX(e) - this.#startX);
    const dy = Math.abs(this.#getPageY(e) - this.#startY);
    if (dx > dy && e.cancelable) e.preventDefault();
    this.#moveDrag(e);
  };

  #onClick = (e) => {
    const link = e.target.closest("a");
    if (this.#isMoving) {
      e.preventDefault();
      e.stopImmediatePropagation();
      return false;
    }
  };

  #measureAndCacheDOMBatch = () => {
    this.#containerWidth.value = Math.min(
      this.track.clientWidth,
      this.clientWidth,
    );
    const trackStyle = getComputedStyle(this.track);
    const gap = parseFloat(trackStyle.gap) || 0;

    this.#itemWidth.value = this.items[0].offsetWidth + gap;
    const paddingLeft = parseFloat(trackStyle.paddingLeft) || 0;

    this.#maxPosition.value = -(
      this.track.scrollWidth +
      paddingLeft -
      this.#containerWidth.peek()
    );
  };

  #handleResizeTimeout = () => {
    this.measureAndCacheDOM();
    this.#position.value = Math.max(
      this.#maxPosition.peek(),
      Math.min(0, this.#position.peek()),
    );
    this.updateNumberOfBullets();
  };

  // We make handleResize a public arrow function to avoid needing to bind it in the constructor
  handleResize = () => {
    if (this.resizeTimer !== null) clearTimeout(this.resizeTimer);
    this.resizeTimer = setTimeout(this.#handleResizeTimeout, 150);
  };

  // ---------------------------------------------------------------------------
  // Setup & Layout Methods
  // ---------------------------------------------------------------------------

  setupEffects() {
    effect(this.#syncTransform);
    effect(this.#syncButtons);
    effect(this.#syncBullets);
    effect(this.#momentumEffect);
  }

  scrollByBullets(direction) {
    const i = this.#bullets.findIndex(this.#isBulletSelected);
    if (this.#bullets[i + direction]) {
      this.#bullets[i + direction].click();
    }
  }

  snapToNearest() {
    const itemW = this.#itemWidth.peek();
    const index = Math.round(-this.#position.peek() / itemW);
    const clamped = Math.max(0, Math.min(this.items.length - 1, index));
    this.animateTo(Math.max(this.#maxPosition.peek(), -(clamped * itemW)));
  }

  animateTo(target) {
    this.track.style.transition =
      "transform 0.4s cubic-bezier(0.25, 1, 0.5, 1)";
    this.#position.value = target;
    setTimeout(this.#clearTransition, 400);
  }

  updateActiveBullet() {
    if (this.#bullets.length < 2) return;

    let activePageIndex = 0;
    const totalBullets = this.#bullets.length;
    const currentPos = this.#position.peek();
    const maxPos = this.#maxPosition.peek();
    const itemW = this.#itemWidth.peek();

    if (currentPos <= maxPos) {
      activePageIndex = totalBullets - 1;
    } else if (currentPos >= 0) {
      activePageIndex = 0;
    } else if (totalBullets === 2) {
      activePageIndex = currentPos === maxPos ? 1 : 0;
    } else {
      const itemsPerPage = Math.max(
        1,
        Math.floor(this.#containerWidth.peek() / itemW),
      );
      activePageIndex = Math.max(
        0,
        Math.min(
          totalBullets - 1,
          Math.round(-currentPos / (itemW * itemsPerPage)),
        ),
      );
    }

    if (activePageIndex === this.#lastActiveIndex) return;
    this.#lastActiveIndex = activePageIndex;

    for (let i = 0; i < this.#bullets.length; i++) {
      this.#bullets[i].toggleAttribute("data-selected", i === activePageIndex);
    }
  }

  updateNumberOfBullets() {
    const itemW = this.#itemWidth.peek();
    const itemsPerPage = Math.max(
      1,
      Math.floor(this.#containerWidth.peek() / itemW),
    );
    const totalPages = Math.ceil(this.items.length / itemsPerPage);
    const currentButtons = this.pagination.throw.any("button");

    for (let i = 1; i < currentButtons.length; i++) {
      currentButtons[i].remove();
    }

    const template = currentButtons[0];
    this.#bullets = [];

    for (let i = 0; i < totalPages; i++) {
      const bullet = /** @type {HTMLButtonElement} */ (
        template.cloneNode(true)
      );
      const targetPos = Math.max(
        this.#maxPosition.peek(),
        -(i * itemsPerPage * this.#itemWidth.peek()),
      );
      bullet.dataset.target = targetPos.toString();
      bullet.addEventListener("click", this.#onBulletClick);

      this.pagination.appendChild(bullet);
      this.#bullets.push(bullet);
    }

    template.remove();
    if (totalPages < 2) {
      this.pagination.setAttribute("data-hidden", "");
    } else {
      this.pagination.removeAttribute("data-hidden");
    }

    this.#lastActiveIndex = -1;
    this.updateActiveBullet();
  }

  #getPageX(e) {
    return e.touches?.[0]?.pageX ?? e.pageX;
  }

  #getPageY(e) {
    return e.touches?.[0]?.pageY ?? e.pageY;
  }

  addDragListeners() {
    this.addEventListener("mousedown", this.#startDrag);
    this.addEventListener("mousemove", this.#onMouseMove);
    window.addEventListener("mouseup", this.#endDrag);
    this.addEventListener("mouseleave", this.#endDrag);

    this.addEventListener("touchstart", this.#startDrag, { passive: false });
    this.addEventListener("touchmove", this.#onTouchMove, { passive: false });
    window.addEventListener("touchend", this.#endDrag);
    window.addEventListener("touchcancel", this.#endDrag);
    this.addEventListener("click", this.#onClick, true);
  }

  measureAndCacheDOM() {
    batch(this.#measureAndCacheDOMBatch);
  }

  removeDragListeners() {
    window.removeEventListener("mouseup", this.#endDrag);
    window.removeEventListener("touchend", this.#endDrag);
    window.removeEventListener("touchcancel", this.#endDrag);
  }
}

customElements.define("elastic-scroll", ElasticScroll);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["promo-brand-cupcakes"]) return;
  try {
    
// Section-Builder: 01-main.js
class CupcakeTurnPicker extends HTMLElement {
    static MOBILE_QUERY = '(max-width: 767px)';
    static MOBILE_MAX_INDEX = 2; // first 3 items = index 0,1,2
    #mql;
    #cupcakes;
    #mobileOnly;
    #prev = /** @type {HTMLElement | null} */ (null);
    #tickerId;

    constructor() {
      super();
      this.#mql = window.matchMedia(CupcakeTurnPicker.MOBILE_QUERY);
      this.#cupcakes = this.throw.any('[data-bucket]');
      this.#mobileOnly = this.#cupcakes.filter((el) => {
        const attr = el.getAttribute('data-bucket');
        return attr === '1' || attr === '2';
      });
      this.#tickerId = setInterval(async () => {
        this.pickTurn();
      }, 3000);
    }

    disconnectedCallback() {
      clearInterval(this.#tickerId);
    }

    async pickTurn() {
      if (this.#prev) this.#prev.toggleAttribute('data-turn', false);
      const isMobile = this.#mql.matches;
      if (isMobile) {
        const chosen = this.#mobileOnly[Math.floor(Math.random() * this.#mobileOnly.length)];
        chosen.toggleAttribute('data-turn', true);
        return;
      }

      const chosen = this.#cupcakes[Math.floor(Math.random() * this.#cupcakes.length)];
      chosen.toggleAttribute('data-turn', true);
      this.#prev = chosen;
    }
  }

  customElements.define('cupcake-turn-picker', CupcakeTurnPicker);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["promo-same-day"]) return;
  try {
    
// Section-Builder: cutoff-countdown.js
/**
 * @typedef {'hours' | 'minutes' | 'seconds'} TimeUnit
 */

/**
 * @typedef {Record<TimeUnit, string>} TimeParts
 */

class CountdownTimer extends HTMLElement {
  /** @type {number | null} */
  #intervalId = null;

  /** @type {Record<TimeUnit, HTMLElement | null>} */
  #els = { hours: null, minutes: null, seconds: null };

  connectedCallback() {
    /** @type {TimeUnit[]} */
    const units = ["hours", "minutes", "seconds"];
    for (const unit of units) {
      this.#els[unit] = this.throw.element(`[data-name="${unit}"]`);
    }

    this.#tick();
    this.#intervalId = window.setInterval(() => this.#tick(), 1000);
  }

  disconnectedCallback() {
    this.#stop();
  }

  /**
   * Today's target as a Date, parsed from the `target` attribute ("HH:MM" or "HH:MM:SS").
   * @returns {Date | null}
   */
  #getTargetDate() {
    const value = this.getAttribute("target");
    if (!value) return null;

    const [h = NaN, m = 0, s = 0] = value.split(":").map(Number);
    if ([h, m, s].some(Number.isNaN)) return null;

    const target = new Date();
    target.setHours(h, m, s, 0);
    return target;
  }

  /**
   * Split a millisecond duration into zero-padded parts.
   * @param {number} ms
   * @returns {TimeParts}
   */
  #format(ms) {
    const total = Math.max(0, Math.floor(ms / 1000));
    const pad = (/** @type {number} */ n) => String(n).padStart(2, "0");

    return {
      hours: pad(Math.floor(total / 3600)),
      minutes: pad(Math.floor((total % 3600) / 60)),
      seconds: pad(total % 60),
    };
  }

  #tick() {
    const target = this.#getTargetDate();
    if (!target) {
      this.#stop();
      return;
    }

    // Clamped to 0 so it never goes negative or rolls over to tomorrow.
    const remaining = Math.max(0, target.getTime() - Date.now());
    const parts = this.#format(remaining);

    for (const unit of /** @type {TimeUnit[]} */ (Object.keys(parts))) {
      const el = this.#els[unit];
      if (el && el.textContent !== parts[unit]) el.textContent = parts[unit];
    }

    if (remaining === 0) this.#stop();
  }

  #stop() {
    if (this.#intervalId !== null) {
      clearInterval(this.#intervalId);
      this.#intervalId = null;
    }
  }
}

customElements.define("countdown-timer", CountdownTimer);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["promo-scrolling-images"]) return;
  try {
    
// Section-Builder: parallax-scroller.js
class ParallaxScroller extends HTMLElement {
  #buckets;
  #mq;
  #maxOffset = 80;
  #maxOffsetDesktop = 160;
  #ticking = false;
  #reduceMotion = false;
  #bucketConfig;

  /** @type {IntersectionObserver | null} */
  #io = null;
  /** @type {(event?: Event) => void} */
  #onScroll;
  /** @type {() => void} */
  #update;

  constructor() {
    super();

    this.#buckets = Array.from(this.throw.any("[data-parallax]"));
    this.#bucketConfig = new Map(
      this.#buckets.map((bucket) => [
        bucket,
        this.#resolveBucketConfig(bucket),
      ]),
    );
    const breakpoint = parseFloat(this.getAttribute("data-breakpoint")) || 768;
    this.#mq = window.matchMedia(`(min-width: ${breakpoint}px)`);
    this.#ticking = false;
    this.#reduceMotion = false;
    this.#io = null;

    this.#onScroll = this.#handleScroll.bind(this);
    this.#update = this.#handleUpdate.bind(this);
  }

  connectedCallback() {
    this.#io = new IntersectionObserver(
      (entries) => {
        const active = entries[0].isIntersecting;
        if (active) {
          window.addEventListener("scroll", this.#onScroll, { passive: true });
          window.addEventListener("resize", this.#onScroll, { passive: true });
          this.#onScroll();
        } else {
          window.removeEventListener("scroll", this.#onScroll);
          window.removeEventListener("resize", this.#onScroll);
        }
      },
      { rootMargin: "20% 0px 20% 0px" },
    );
    this.#io.observe(this);

    // Respect reduced-motion preference.
    this.#reduceMotion = window.matchMedia(
      "(prefers-reduced-motion: reduce)",
    ).matches;
    if (this.#reduceMotion) return;

    this.#update();
  }

  disconnectedCallback() {
    window.removeEventListener("scroll", this.#onScroll);
    window.removeEventListener("resize", this.#onScroll);
    if (this.#io) this.#io.disconnect();
  }

  /**
   * Throttled scroll/resize handler; schedules a single rAF update.
   * @param {Event} [_event]
   * @returns {void}
   */
  #handleScroll(_event) {
    if (this.#reduceMotion || this.#ticking) return;
    this.#ticking = true;
    requestAnimationFrame(this.#update);
  }

  /**
   * Reads a bucket's static data-attributes once and normalizes them into a config object.
   *
   * @typedef {Object} AxisConfig
   * @property {string} axis - The movement axis.
   * @property {number} dir - The direction multiplier (-1 or 1).
   *
   * @typedef {Object} BucketConfig
   * @property {AxisConfig | null} desktop - Configuration for desktop breakpoint, or null if invalid.
   * @property {AxisConfig | null} mobile - Configuration for mobile breakpoint, or null if invalid.
   *
   * @param {HTMLElement} bucket - The bucket element containing static data attributes.
   * @returns {BucketConfig} The normalized breakpoint configuration object.
   */
  #resolveBucketConfig(bucket) {
    /** @param {string|undefined} axis @param {string|undefined} dirAttr */
    const normalize = (axis, dirAttr) => {
      const dir = parseFloat(dirAttr ?? "");
      if (axis !== "x" && axis !== "y") return null;
      if (Number.isNaN(dir)) return null;
      return { axis, dir };
    };

    return {
      desktop: normalize(bucket.dataset.desktopAxis, bucket.dataset.desktopDir),
      mobile: normalize(bucket.dataset.mobileAxis, bucket.dataset.mobileDir),
    };
  }

  /**
   * Computes scroll progress and applies transforms to each bucket.
   * @returns {void}
   */
  #handleUpdate() {
    this.#ticking = false;

    const rect = this.getBoundingClientRect();
    const vh = window.innerHeight || document.documentElement.clientHeight;
    const total = vh + rect.height;

    // 0 = component just entering from bottom, 1 = fully scrolled past top.
    let progress = (vh - rect.top) / total;
    progress = Math.min(1, Math.max(0, progress));

    // -1 .. 1, centered at the midpoint of the scroll-through.
    const centered = (progress - 0.5) * 2;
    const isDesktop = this.#mq.matches;

    this.#buckets.forEach((bucket) => {
      const config = this.#bucketConfig.get(bucket);
      const active = isDesktop ? config?.desktop : config?.mobile;

      if (!active) {
        bucket.style.transform = "";
        return;
      }
      const maxOffset = isDesktop ? this.#maxOffsetDesktop : this.#maxOffset;

      const offset = centered * maxOffset * active.dir;
      bucket.style.transform =
        active.axis === "x"
          ? `translate3d(${offset}px,0,0)`
          : `translate3d(0,${offset}px,0)`;
    });
  }
}

customElements.define("parallax-scroller", ParallaxScroller);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["testimonial-moving-images"]) return;
  try {
    
// Section-Builder: 01-main.js
document.addEventListener('DOMContentLoaded', function () {
    const sections = document.querySelectorAll('[data-snap-background-color]');
    const defaultColor = getComputedStyle(document.documentElement)
      .getPropertyValue('--color-background')
      .trim();

    const intersecting = new Set();

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          const ratio = entry.intersectionRatio;

          if (ratio >= 0.8) {
            // Section is dominant — activate it
            intersecting.add(entry.target);
          } else if (ratio < 0.1) {
            // Section has nearly left — deactivate it
            intersecting.delete(entry.target);
          }
          // Between 0.1–0.8: do nothing, hold current state
        });

        if (intersecting.size > 0) {
          const active = [...intersecting].at(-1);
          const color = active.getAttribute('data-snap-background-color');
          document.documentElement.style.setProperty(
            '--color-background',
            color,
          );
        } else {
          document.documentElement.style.setProperty(
            '--color-background',
            defaultColor,
          );
        }
      },
      {
        threshold: [0, 0.1, 0.8, 1.0],
      },
    );

    sections.forEach((el) => observer.observe(el));
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["testimonial-video-carousel"]) return;
  try {
    
// Section-Builder: 01-main.js
class VideoCarousel extends HTMLElement {
    #sectionVisible = false;
    #activeIndex = 0;
    #io = /** @type {IntersectionObserver | null} */ (null);
    #scrollEndTimer = null;
    #onClick = null;
    #onScroll = null;
    #onScrollEnd = null;

    connectedCallback() {
      const activeIndex = this.getAttribute('data-active');
      if (activeIndex) {
        this.#activeIndex = parseInt(activeIndex);
        this.activate(activeIndex, { scroll: true });
      } else {
        this.#activeIndex = this.calculateInitialActiveIndex();
      }
      this.setupSectionObserver();
      this.setupClickHandlers();
      this.setupSwipeHandlers();
    }

    disconnectedCallback() {
      if (this.#io) this.#io.disconnect();
      if (this.#onScroll) this.removeEventListener('scroll', this.#onScroll);
      if (this.#onScrollEnd)
        this.removeEventListener('scrollend', this.#onScrollEnd);
      if (this.#scrollEndTimer) clearTimeout(this.#scrollEndTimer);
    }

    get cards() {
      return Array.from(this.querySelectorAll('.video-card'));
    }

    calculateInitialActiveIndex() {
      const cards = this.cards;
      const defaultIndex = cards.findIndex(
        (card) => card.dataset.default === 'true',
      );
      return Math.max(0, defaultIndex);
    }

    setupSectionObserver() {
      this.#io = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            this.#sectionVisible = entry.isIntersecting;
            if (this.#sectionVisible) {
              this.playActive();
            } else {
              this.pauseAll();
            }
          });
        },
        { threshold: 0.35 },
      );
      this.#io.observe(this);
    }

    setupClickHandlers() {
      this.#onClick = (e) => {
        const card = e.target.closest('.video-card');
        if (!card) return;
        const index = Number(card.dataset.index);
        this.activate(index, { scroll: true });
      };
      this.addEventListener('click', this.#onClick);
    }

    setupSwipeHandlers() {
      const reel = this.throw.element('[data-name="reel"]');
      this.#onScrollEnd = () => this.handleSwipeSettled();
      reel.addEventListener('scrollend', this.#onScrollEnd);
    }

    handleSwipeSettled() {
      const index = this.findCenteredIndex();
      if (index === -1) return;
      // Already centered by the user's swipe/snap — don't re-trigger a scroll.
      this.activate(index, { scroll: false });
    }

    findCenteredIndex() {
      const cards = this.cards;
      if (!cards.length) return -1;
      const containerRect = this.getBoundingClientRect();
      const containerCenter = containerRect.left + containerRect.width / 2;

      let closestIndex = -1;
      let closestDistance = Infinity;
      cards.forEach((card, i) => {
        const rect = card.getBoundingClientRect();
        const cardCenter = rect.left + rect.width / 2;
        const distance = Math.abs(cardCenter - containerCenter);
        if (distance < closestDistance) {
          closestDistance = distance;
          closestIndex = i;
        }
      });
      return closestIndex;
    }

    activate(index, { scroll = false } = {}) {
      if (index === this.#activeIndex) {
        if (scroll) this.centerCard(index);
        return;
      }
      this.pauseAll();
      this.#activeIndex = index;
      this.updateVisualState();
      if (scroll) this.centerCard(index);
      if (this.#sectionVisible) this.playActive();
    }

    centerCard(index) {
      const card = this.cards[index];
      const container = card?.parentElement; // or reference your scroll container directly

      if (card && container) {
        // Distance from the container's left edge to the center of the card
        const targetLeft =
          card.offsetLeft - container.clientWidth / 2 + card.clientWidth / 2;

        container.scrollTo({
          left: targetLeft,
          behavior: 'smooth',
        });
      }
    }

    updateVisualState() {
      this.cards.forEach((card, i) => {
        card.toggleAttribute('data-active', i === this.#activeIndex);
      });
    }

    playActive() {
      const card = this.cards[this.#activeIndex];
      if (!card) return;
      this.updateVisualState();
      if (card.dataset.type === 'image') return;
      const video = card.querySelector('[data-role="video"]');
      const source = card.querySelector('[data-role="source"]');
      const poster = card.querySelector('[data-role="poster"]');
      if (!video || !source) return;
      // Load the video source if it hasn't been set yet (lazy load logic)
      if (!source.src && source.dataset.src) {
        source.src = source.dataset.src;
        source.type = source.dataset.videoType;
        video.load();
      }
      const onPlaying = () => {
        video.classList.remove('opacity-0');
        if (poster) poster.classList.add('opacity-0');
        video.removeEventListener('playing', onPlaying);
      };
      video.addEventListener('playing', onPlaying);
      video.play().catch(() => {
        // autoplay blocked or aborted — keep poster visible
        video.classList.add('opacity-0');
        if (poster) poster.classList.remove('opacity-0');
      });
    }

    pauseAll() {
      this.cards.forEach((card) => {
        const video = card.querySelector('[data-role="video"]');
        const poster = card.querySelector('[data-role="poster"]');
        if (video && !video.paused) video.pause();
        if (video) video.classList.add('opacity-0');
        if (poster) poster.classList.remove('opacity-0');
      });
    }
  }
  customElements.define('video-carousel', VideoCarousel);

  } catch(e) { console.error(e); }
})();
})();
